































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import SubMenuTemplate from '@/views/SubMenuTemplate.vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import AmetrasSearchField from '@/fields/text/AmetrasSearchField.vue';
import {URL_SERVICE_INSTANCE} from '@/services/url.service';
import {isEqual, set} from 'lodash';
import AmetrasButtonTemplate, {AmetrasBtnEventData} from '@/fields/button/AmetrasButtonTemplate.vue';
import {
  AdvancedFieldFunctionConfiguration
} from '@/fields/advanced-field-function-executor/advanced-field-function-configuration';
import {ExtendedDynamicComponentList} from '@/fields/advanced-field-function-executor/conditional-components.interface';
import {COLOR_SERVICE_INSTANCE, ColorService} from '@/services/style/color.service';
import {FONT_SERVICE_INSTANCE, FontService} from '@/services/style/font.service';
import AlertDialog from '@/views/AlertDialog.vue';
import PromtDialog from '@/views/PromtDialog.vue';
import {AxiosResponse} from 'axios';
import AmetrasAdvancedButtonTemplate from '@/fields/button/AmetrasAdvancedButtonTemplate.vue';
import {SaveRequestType} from '@/fields/field-event-types';
import AdvancedConfirmDialog, {
  ConfirmationDialogButton,
  ConfirmationDialogConfig
} from '@/views/AdvancedConfirmDialog.vue';
import {AmetrasAdvancedButtonEvent} from '@/fields/button/AmetrasAdvancedButtonTemplate.interface';
import AmetrasHeadlineFieldTemplate from '@/fields/text/AmetrasHeadlineFieldTemplate.vue';
import AmetrasInfoLabelFieldTemplate from '@/fields/text/AmetrasInfoLabelFieldTemplate.vue';
import AmetrasFormularWrapper from '@/views/AmetrasFormularWrapper.vue';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import {AMETRAS_PARAM_UTILS} from '@/utils/params.utils';
import {CompositeKeyType} from '@/interfaces/key.interface';
import ConditionalComponentRenderer from '@/fields/advanced-field-function-executor/ConditionalComponentRenderer.vue';
import {FIELD_EVENTS_INSTANCE, VueOnMapType} from '@/fields/field-events';
import {GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE} from '@/services/global-event-listener.service';
import {
  AmetrasAdvancedFieldState,
  AmetrasDisabledReasons,
  AmetrasHiddenReasons
} from '@/fields/advanced-field-function-executor/field-state-executor';
import {BehaviorSubject, Subject, Subscription} from 'rxjs';
import {SUBJECT_UTILS_INSTANCE} from '@/utils/subject.utils';
import {ICONS_SERVICE_INSTANCE} from '@/utils/icons.service';
import {
  AmetrasDialogCtrlConfiguration,
  DialogType,
  ExtendedFTField,
  ExtendedFTGridColumnDto,
  ExtendedFTRowDto,
  ExtendedIFormularContentUnion,
  ExtendedIFTRowElementUnion,
  FormularCloseEventData,
  FormularInstance,
  FTSubMenuConfig
} from './form.interface';
import {FtReplacementTokenService} from '@/utils/ft-replacement-token.service';
import {DYNAMIC_FIELD_RESOLVER_INSTANCE} from '@/fields/dynamic-field-resolver';
import {apply} from 'json-logic-js';
import {AmetrasAdvancedButtonState} from '@/fields/advanced-field-function-executor/button-state-executor';
import AmetrasDynamicContentDialog from '@/views/AmetrasDynamicContentDialog.vue';
import ReloadAfterEventFTEventDto = DisguiseDto.ReloadAfterEventFTEventDto;

interface FormularConfig {
  create: boolean;
  templateUrl: string;
  entityUrl: string;
}

// Custom Events: save
@Component({
  name: 'form-template',
  components: {
    AmetrasDynamicContentDialog,
    ConditionalComponentRenderer,
    AmetrasFormularWrapper,
    AmetrasAdvancedButtonTemplate,
    AdvancedConfirmDialog,
    AlertDialog,
    PromtDialog,
    AmetrasSearchField,
    AmetrasButtonTemplate,
    SubMenuTemplate,
    AmetrasHeadlineFieldTemplate,
    AmetrasInfoLabelFieldTemplate
  }
})
export default class FormTemplate extends Vue {

  /**
   * Fields Without a value should not be sent to the API.
   *
   * The Formular renders everything coming with different UI Types.
   * During save, all fields and their value will be collected.
   * In case of specific fields, e.g. a button, we must not send a value to the API
   */
  private static readonly UI_TYPES_WITHOUT_VALUE: DisguiseDto.EnumUiType[] = [
    'BUTTON',
    'GMAPS',
    'PDF',
    'TABLE'
  ];

  @Prop({type: Boolean, default: false}) create!: boolean;
  @Prop() context!: any;
  // indication whether the formular should be prefetched (loaded in create=true mode)
  @Prop({type: Boolean, required: false, default: true}) prefetch!: boolean;
  @Prop({type: String, required: false, default: ''}) templateUrl!: string;
  @Prop({type: String, required: false, default: ''}) entityUrl!: string;
  @Prop({
    required: false, default: () => {
      return null;
    }
  }) formular!: DisguiseDto.FTDefinitionDto | null;
  @Prop({type: String, required: false}) title!: string;
  @Prop({
    type: Object as () => CompositeKeyType,
    required: false,
    default: () => {
      return {};
    }
  }) primaryKey!: CompositeKeyType;
  @Prop({
    default: 'ma-0'
  }) marginDefinition!: string;
  @Prop() contentClass!: string;
  @Prop({
    default: 'pa-0'
  }) paddingDefinition!: string;
  @Prop() containerStyle!: { [cssProp: string]: string };
  @Prop({
    default: () => ({})
  }) overwrittenFields!:
      { [fieldName: string]: DisguiseDto.FTFieldDto }; // you can overwrite fields via keys from outside
  @Prop() disableEvenOddStyle!: boolean; // disable the different white and grey highlighting per row
  @Prop({
    default: null
  }) userRequestedReload!: BehaviorSubject<string> | null; // whenever a user requests a reload, e.g. by submenu tab
  @Prop({
    default: true
  }) reloadOnUserRequest!: boolean; // configuration whether the reload (e.g. by submenu click) will always refresh the content

  formularConfig!: FormularConfig;

  initialDataLoaded: boolean = false; // indication whether the initial data has been loaded
  origInput: DisguiseDto.FTDefinitionDto = {};

  fieldFunctionConfiguration: AdvancedFieldFunctionConfiguration | undefined;
  colorService: ColorService = COLOR_SERVICE_INSTANCE;
  fontService: FontService = FONT_SERVICE_INSTANCE;
  showFormularDialog: boolean = false;
  formularDialog: DialogType | null = null;

  confirmationDialogConfig: ConfirmationDialogConfig | null = null;
  confirmationDialogConfigRerenderCounter: number = 0; // force refresh by increasing the key property
  // synchroner Re-Entry-Schutz gegen Doppelklick auf "Bestaetigen" im Loesch-Dialog.
  // Der eigentliche DELETE liegt hinter einer asynchronen Kette (nextTick + AFFE-Wait), waehrend
  // der Dialog offen bleibt -> ohne dieses Flag liessen sich mehrere DELETE-Requests ausloesen.
  private confirmActionPending: boolean = false;
  instance: FormularInstance = {
    valid: false, // indication whether the formular is valid and there is no field invalid
    loading: false, // indication whether there is currently a HTTP Operation pending
    dirty: false, // indication whether the formular is dirty / has uncommitted changes
    doDelete: this.doDelete,
    onSubmit: this.onSubmit,
    serializeFormularElementValues: this.serializeFormularElementValues,
    input: {}
  };

  fieldStates: {
    [uniqueFieldName: string]: AmetrasAdvancedFieldState
  } = {};
  buttonStates: {
    [uniqueButtonId: string]: AmetrasAdvancedButtonState
  } = {};

  subMenu: FTSubMenuConfig | null = null;

  conditionalComponents: ExtendedDynamicComponentList = {
    componentsByIdentifier: {}
  };

  $refs!: {
    formWrapper: AmetrasFormularWrapper,
    alert: AlertDialog,
    promt: PromtDialog
  };
  iconService = ICONS_SERVICE_INSTANCE;

  private userRequestedReloadSubscription: Subscription | undefined;
  private lastUserRequestedReloadReqId: string = '';

  private registeredGlobalEventListenerNames: string[] = [];
  private pendingAFFERequestCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  @Watch('templateUrl') templateUrlChanged(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.formularConfig = {
        ...this.formularConfig,
        templateUrl: newValue
      };
      this.loadData();
    }
  }

  @Watch('entityUrl') entityUrlChanged(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.formularConfig = {
        ...this.formularConfig,
        entityUrl: newValue
      };
      this.loadData();
    }
  }

  @Watch('create') createChanged(newValue: boolean, oldValue: boolean) {
    if (newValue !== oldValue) {
      this.formularConfig = {
        ...this.formularConfig,
        create: newValue
      };
      this.loadData();
    }
  }

  @Watch('primaryKey') primaryKeyChanged(
      newValue: CompositeKeyType,
      oldValue: CompositeKeyType
  ) {
    if (!isEqual(newValue, oldValue)) {
      this.loadData();
    }
  }

  @Watch('userRequestedReload') userRequestedReloadChanged() {
    this.bindToReload();
  }

  fieldButtonClicked(referenceName: string, slot: 'append' | 'prepend' | 'appendOuter' | 'prependOuter', event: MouseEvent) {
    const fieldReference = this.lookupFieldReference(referenceName);
    if (fieldReference === undefined) {
      throw new Error('Unknown field reference');
    }
    if (slot === 'prepend') {
      fieldReference.$emit('click:prepend', event);
    } else if (slot === 'prependOuter') {
      fieldReference.$emit('click:prepend-outer', event);
    } else if (slot === 'append') {
      fieldReference.$emit('click:append', event);
    } else if (slot === 'appendOuter') {
      fieldReference.$emit('click:append-outer', event);
    }
  }

  openSubNavi(response: DisguiseDto.RedirectDto) {
    this.showFormularDialog = false;
    this.formularDialog = null;
    const castedResponse = response as DisguiseDto.RedirectDto;
    if (castedResponse.actionType && castedResponse.actionType['@type'] === 'SubMenuRedirectActionType') {
      if ((castedResponse.actionType.openInParentDepthIdx || 0) > 1) {
        castedResponse.actionType.openInParentDepthIdx = (castedResponse.actionType.openInParentDepthIdx || 0) - 1;
        this.$emit('subnaviinparent', castedResponse);
      } else {
        this.conditionalComponents.componentsByIdentifier = {};
        this.subMenu = {
          url: castedResponse.actionType.url || '',
          contextParameter: castedResponse.actionType.contextParameter,
          title: '',
          breadcrumbs: [],
          actionConfiguration: castedResponse.actionType
        };
      }
    }
  }

  created() {
    this.$emit('created', this.instance);
    this.formularConfig = {
      create: this.create,
      templateUrl: this.templateUrl,
      entityUrl: this.entityUrl
    };
    this.loadData();
    this.attachKeyListener();
  }

  mounted() {
    this.bindToReload();
  }

  destroyed() {
    this.detachKeyListener();

    this.unregisterAllGlobalEventListeners();

    if (this.userRequestedReloadSubscription) {
      this.userRequestedReloadSubscription.unsubscribe();
    }
  }

  buildRestURL(restURL: string): string {
    const params: CompositeKeyType = this.buildApiCallParameters();
    return restURL + (restURL.indexOf('?') > 0 ? '&' : '?') + URL_SERVICE_INSTANCE.serialize(params);
  }

  addFieldToParams(field: DisguiseDto.FTFieldDto,
                   params: CompositeKeyType) {
    // fields of type FTFieldDto have their model stored within this.fieldValues
    const alternativeValue = this.fieldStates[field.customReferenceName || field.fieldName || '']
        ? this.fieldStates[field.customReferenceName || field.fieldName || '']
        : null;
    const alternativeValueAvailable = alternativeValue && alternativeValue.value !== undefined;

    const targetDtoPath = field.endpointKeyPath !== undefined ? field.endpointKeyPath : field.fieldName;

    if (targetDtoPath && alternativeValueAvailable && alternativeValue) {
      set(params,
          targetDtoPath,
          alternativeValue.value
      );
    } else if (targetDtoPath && (field.value !== undefined && field.value !== null)) {
      set(params, targetDtoPath, field.value);
    } else if (targetDtoPath && (field.selectValues !== undefined && field.selectValues !== null)) {
      const fields = [];
      for (const currentId of field.selectValues || []) {
        const idValues: { [key: string]: string } = {};
        for (const currentValuePairKey of Object.keys(currentId.ids || {})) {
          idValues['id[' + currentValuePairKey + ']'] = (currentId.ids || {})[currentValuePairKey];
        }
        fields.push({
          text: currentId.text || '',
          ...idValues
        });
      }
      set(params, targetDtoPath, fields);
    }
    return params;
  }

  emitClose(closeEventData?: FormularCloseEventData) {
    if (this.formularDialog) {
      this.showFormularDialog = false;
      this.formularDialog = null;
    }

    this.triggerOnCloseEvents();

    this.$emit('close', closeEventData);
  }

  triggerOnCloseEvents() {
    for (const closeAction of (this.instance.input.onCloseActions || [])) {
      if (closeAction['@type'] === 'FTPropagateGlobalEventDto') {
        const globalEvent = closeAction as DisguiseDto.FTPropagateGlobalEventDto;
        GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.notifyListener(globalEvent.event || '', globalEvent.globalEventAction);
      }
    }
  }

  serializeFormularElementValues() {
    return new Promise<CompositeKeyType>((resolve, reject) => {
      this.delayUntilPendingAffeRequestCountIsZeroAndFormularIsValid(
          () => {
            this.$nextTick(() => {
              resolve(this.buildApiCallParameters());
            });
          },
          reject
      );
    });
  }

  save(customEndpointUrl?: string, additionalParams?: CompositeKeyType) {
    return new Promise<AxiosResponse>((resolve, reject) => {
      this.instance.loading = true;

      // wait until AFFE created the necessary requests by waiting for next tick
      this.serializeFormularElementValues().then((params) => {
        const combinedParams = {
          ...params,
          ...(additionalParams || {})
        };
        if (!this.instance.input.submitWithBody) {
          if (this.formularConfig.create) {
            HTTP_SERVICE_INSTANCE.getAxios().post(
                this.buildRestURL(
                    customEndpointUrl || this.buildApiCallUrlPrefix()
                )).then((response) => {
              this.handleSaveResponse(response);
              this.$emit('save', {...response.data, _req: combinedParams});
              resolve(response);
            }, (error) => {
              this.handleSaveError(error, customEndpointUrl, combinedParams);
              reject(error);
            });
          } else {
            HTTP_SERVICE_INSTANCE.getAxios().put(
                this.buildRestURL(
                    customEndpointUrl || this.buildApiCallUrlPrefix()
                )).then((response) => {
              this.handleSaveResponse(response);
              this.$emit('save', {...response.data, _req: combinedParams});
              resolve(response);
            }, (error) => {
              this.handleSaveError(error, customEndpointUrl, combinedParams);
              reject(error);
            });
          }
        } else {
          const submitUrl = customEndpointUrl || this.buildApiCallUrlPrefix();
          if (this.formularConfig.create) {
            HTTP_SERVICE_INSTANCE.getAxios().post(submitUrl, combinedParams).then((response) => {
              this.handleSaveResponse(response);
              this.$emit('save', {...response.data, _req: combinedParams});
              resolve(response);
            }, (error) => {
              this.handleSaveError(error, customEndpointUrl, combinedParams);
              reject(error);
            });
          } else {
            HTTP_SERVICE_INSTANCE.getAxios().put(submitUrl, combinedParams).then((response) => {
              this.handleSaveResponse(response);
              this.$emit('save', {...response.data, _req: combinedParams});
              resolve(response);
            }, (error) => {
              this.handleSaveError(error, customEndpointUrl, combinedParams);
              reject(error);
            });
          }
        }
      });
    });
  }

  doDelete() {
    this.instance.loading = true;
    this.$nextTick(() => {
      // wait until AFFE created the necessary requests by waiting for next tick
      SUBJECT_UTILS_INSTANCE.delayUntilSubjectMatchesFilterConditionOnce(
          this.pendingAFFERequestCount,
          (currentCount) => currentCount === 0,
          () => {
            this.$nextTick(() => {
              // wait until AFFE updated the data based on results by waiting for next tick
              HTTP_SERVICE_INSTANCE.getAxios().delete(this.buildRestURL(this.buildApiCallUrlPrefix())).then((response) => {
                this.handleSaveResponse(response);
                this.$emit('delete', response);
              }).catch((error) => {
                if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
                  this.$store.commit('showSnack', {
                    message: 'Speichern fehlgeschlagen',
                    color: 'error'
                  });
                }
              });
            });
          },
          () => {
            // any further error is already handled within the corresponding request.
          }
      );

    });
  }

  handleSaveResponse(response: AxiosResponse) {
    if ([301, 302].indexOf(response.status) < 0) {
      this.triggerOnSaveActions();
      this.$store.commit('showSnack', {
        message: 'Speichern erfolgreich',
        color: 'success'
      });

      if (response.data['@type'] === 'FTAfterSaveActionDto') {
        const config = response.data as DisguiseDto.FTAfterSaveActionDto;
        if (config.actions) {
          for (const action of config.actions) {
            if (action['@type'] === 'FTPropagateGlobalEventDto') {
              if (action.event !== undefined
                  && action.globalEventAction !== undefined) {
                GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.notifyListener(
                    action.event,
                    action.globalEventAction
                );
              } else {
                throw new Error('event or globalEventAction undefined!');
              }
            }
          }
        }
      }
    } else {
      const castedResponse = response.data as DisguiseDto.RedirectDto;
      if (castedResponse) {
        if (castedResponse.optionalUserSuccessMessage) {
          this.$store.commit('showSnack', {
            message: castedResponse.optionalUserSuccessMessage,
            color: 'success'
          });
        }
        if (castedResponse.actionType && castedResponse.actionType['@type'] === 'SubMenuRedirectActionType') {
          if ((castedResponse.actionType.openInParentDepthIdx || 0) > 0) {
            this.$emit('subnaviinparent', castedResponse);
          } else {
            this.conditionalComponents.componentsByIdentifier = {};
            this.subMenu = {
              url: castedResponse.actionType.url || '',
              contextParameter: castedResponse.actionType.contextParameter,
              title: '',
              breadcrumbs: [],
              actionConfiguration: castedResponse.actionType
            };
          }
        } else if (castedResponse.actionType && castedResponse.actionType['@type'] === 'SubMenuSwitchTabActionType') {
          this.$emit('switchsubmenu', castedResponse.actionType.naviEntryId);
        } else if (castedResponse.actionType && castedResponse.actionType['@type'] === 'FormularDialogRedirectActionType') {
          this.formularDialog = {
            formular: {
              'templateUrl': castedResponse.actionType.formularUrl || '',
              'entityUrl': castedResponse.actionType.entityUrl || '',
              '@type': 'FORMULAR'
            },
            dialogTitle: castedResponse.actionType.dialogTitle,
            title: castedResponse.actionType.dialogTitle,
            create: castedResponse.actionType.create || false,
            widthPercentage: castedResponse.actionType.widthPercentage,
            maxWidthInPx: castedResponse.actionType.maxWidthInPx,
            canSubmit: true,
            onAbort: () => {
              if (castedResponse.actionType && castedResponse.actionType.events) {
                for (const event of castedResponse.actionType.events) {
                  if (event.type === 'ReloadAfterCloseRedirectDto') {
                    this.loadData();
                  }
                }
              }
              this.showFormularDialog = false;
              this.formularDialog = null;
            },
            events: ((events?: DisguiseDto.RedirectEventDtoUnion[]) => {
              const result: DisguiseDto.FTEventV2DtoUnion[] = [];

              for (const currentEvent of events || []) {
                if (currentEvent.type === 'ReloadAfterSaveRedirectDto') {
                  result.push({
                    type: 'ReloadAfterEventFTEventDto',
                    eventName: 'save'
                  });
                }
              }

              return result;
            })(castedResponse.actionType.events),
            onClose: (closeArgs: FormularCloseEventData) => {
              if (castedResponse.actionType && castedResponse.actionType.events) {
                for (const event of castedResponse.actionType.events) {
                  if (event.type === 'ReloadAfterCloseRedirectDto') {
                    this.loadData();
                  }
                }
              }
              this.showFormularDialog = false;
              this.formularDialog = null;
            }
          };
          this.showFormularDialog = true;
        }
      }
    }
    this.instance.loading = false;
    this.instance.dirty = false;
  }

  loadData() {
    if (this.instance.input.rows) {
      this.overwriteFields(this.instance.input.rows, true);
      if (this.$refs.formWrapper) {
        this.$refs.formWrapper.resetValidation();
      }
    }
    this.instance.loading = true;

    if (!this.formular) {
      let templateURL = `${this.formularConfig.templateUrl}`;
      if (templateURL.indexOf('?') >= 0) {
        templateURL += `&`;
      } else {
        templateURL += '?';
      }

      const params: CompositeKeyType = {create: String(this.formularConfig.create)};
      for (const keyElementName of Object.keys(this.primaryKey)) {
        const keyElementValue = this.primaryKey[keyElementName];
        // check if param is already in url
        const keyParamNotAlreadyPresentInTemplateUrl = templateURL.indexOf(keyElementName + '=') < 0;
        if (keyParamNotAlreadyPresentInTemplateUrl) {
          // define the param
          params[keyElementName] = keyElementValue;
        }
      }

      templateURL += URL_SERVICE_INSTANCE.serialize(params);
      HTTP_SERVICE_INSTANCE.getAxios()
          .get<DisguiseDto.FTDefinitionDto>(templateURL)
          .then((response) => {
            this.afterLoadData(response.data);
          }, (error) => {
            if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
              this.$store.commit('showSnack', {
                message: 'Laden des Datensatzes fehlgeschlagen',
                color: 'error'
              });
            }
            this.instance.loading = false;
            this.emitClose({
              error: true
            });
          });
    } else {
      this.afterLoadData(this.formular);
    }
  }

  confirmLosingChanges() {
    if (!this.instance.dirty) {
      // close the dialog and we are done here
      this.emitClose();
      return;
    }

    // in order to prevent escape button loops, we have to temporarily detatch the escape key listener
    this.detachKeyListener();
    const confirmed = confirm('Wollen Sie Ihre Änderungen verwerfen?');
    // once we got the answer, let's connect it again.
    this.attachKeyListener();
    if (confirmed) {
      // if the user confirmed, we are done
      this.emitClose();
    }
  }

  setFocus() {
    // temporarily disabled due to performance reasons (if endlessly called)
    // todo: repair endless loop & enable again!
    /**
     * if (this.$refs.field && this.$refs.form instanceof Vue) {
     * const vueForm = this.$refs.form as Vue;
     * HTML_SERVICE_INSTANCE.focusFirstNode(vueForm.$el);
     * } else {
     * setTimeout(this.setFocus, 50);
     * }
     */
  }

  /**
   * Form submission
   */
  onSubmit() {
    if (this.instance.input.canSubmit) {
      this.delayUntilPendingAffeRequestCountIsZeroAndFormularIsValid(() => {
        this.save();
      }, () => {
        this.$store.commit('showSnack', {
          message: 'Bitte beheben Sie die Fehler in allen rot markierten Feldern',
          color: 'warn'
        });
      });
    }
  }

  onAmetrasBtnClick(ametrasBtnEvent: AmetrasBtnEventData) {
    ametrasBtnEvent.buttonState.loading = true;
    const submitUrl = ametrasBtnEvent.url || '';
    const params: CompositeKeyType = this.buildApiCallParameters();
    switch (ametrasBtnEvent.button) {
      case 'SUBMITADDRESSES':
        this.confirmationDialogConfig = {
          title: 'Bestätigen',
          headerColor: 'primary',
          message: 'Wollen Sie die Lieferadresse in allen Adressen übertragen?',
          buttons: [{
            text: 'Bestätigen',
            title: 'Bestätigen',
            disabled: false,
            loading: false,
            autoFocus: true,
            onClick: (button: ConfirmationDialogButton) => {
              // synchroner Doppelklick-Schutz (analog case 'DELETE').
              if (this.confirmActionPending) {
                return;
              }
              this.confirmActionPending = true;
              button.loading = true;
              button.disabled = true;
              this.confirmationDialogConfigRerenderCounter++;
              this.$nextTick(() => {
                // wait until AFFE created the necessary requests by waiting for next tick

                SUBJECT_UTILS_INSTANCE.delayUntilSubjectMatchesFilterConditionOnce(
                    this.pendingAFFERequestCount,
                    (currentCount) => currentCount === 0,
                    () => {
                      this.$nextTick(() => {
                        // wait until AFFE updated the data based on results by waiting for next tick
                        HTTP_SERVICE_INSTANCE.getAxios().put(submitUrl, params).then(() => {
                          ametrasBtnEvent.buttonState.loading = false;
                          this.loadData();
                          this.$store.commit('showSnack', {
                            message: 'Übernahme erfolgreich',
                            color: 'success'
                          });
                          this.confirmationDialogConfig = null;
                        }, (error) => {
                          if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
                            ametrasBtnEvent.buttonState.loading = false;
                            this.$store.commit('showSnack', {
                              message: 'Übernahme fehlgeschlagen',
                              color: 'error'
                            });
                          }
                          button.loading = false;
                          button.disabled = false;
                        }).finally(() => {
                          this.confirmActionPending = false;
                        });
                      });
                    },
                    () => {
                      ametrasBtnEvent.buttonState.loading = false;
                      button.loading = false;
                      button.disabled = false;
                      this.confirmActionPending = false;
                      // any further error is already handled within the corresponding request.
                    }
                );
              });

            }
          }, {
            text: 'Abbrechen',
            title: 'Abbrechen',
            disabled: false,
            loading: false,
            onClick: () => {
              ametrasBtnEvent.buttonState.loading = false;
              this.confirmationDialogConfig = null;
            }
          }],
          onEsc: () => {
            ametrasBtnEvent.buttonState.loading = false;
            this.confirmationDialogConfig = null;
          }
        };
        this.confirmationDialogConfigRerenderCounter ++;

        break;
      case 'OPENSUBMENU':
        this.conditionalComponents.componentsByIdentifier = {};
        this.subMenu = {
          url: ametrasBtnEvent.url || '',
          contextParameter: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(ametrasBtnEvent.urlParameters),
          title: '',
          breadcrumbs: []
        };
        ametrasBtnEvent.buttonState.loading = false;
        break;
      case'CONFIRMBUTTON':
        this.executeDialogCtrl({
          promtInput: ametrasBtnEvent.promtInput,
          buttonState: ametrasBtnEvent.buttonState,
          url: ametrasBtnEvent.url,
          dialogId: ametrasBtnEvent.dialogId,
          urlParameters: ametrasBtnEvent.urlParameters,
          eventData: []
        });
        break;
      case 'DELETE':
        this.confirmationDialogConfig = {
          title: 'Bestätigen',
          headerColor: 'primary',
          message: 'Möchten Sie dieses Element löschen?',
          buttons: [{
            text: 'Bestätigen',
            title: 'Bestätigen',
            disabled: false,
            loading: false,
            autoFocus: true,
            onClick: () => {
              // synchroner Doppelklick-Schutz - faengt einen zweiten Klick sofort ab,
              // bevor die asynchrone DELETE-Kette (nextTick + AFFE-Wait) erneut starten kann.
              if (this.confirmActionPending) {
                return;
              }
              this.confirmActionPending = true;
              // UX: beide Dialog-Buttons sperren + Spinner am Bestaetigen-Button (Re-Render via :key).
              if (this.confirmationDialogConfig) {
                this.confirmationDialogConfig.buttons.forEach((b, idx) => {
                  b.disabled = true;
                  b.loading = idx === 0;
                });
                this.confirmationDialogConfigRerenderCounter++;
              }
              this.$nextTick(() => {
                // wait until AFFE created the necessary requests by waiting for next tick

                SUBJECT_UTILS_INSTANCE.delayUntilSubjectMatchesFilterConditionOnce(
                    this.pendingAFFERequestCount,
                    (currentCount) => currentCount === 0,
                    () => {
                      this.$nextTick(() => {
                        // wait until AFFE updated the data based on results by waiting for next tick
                        HTTP_SERVICE_INSTANCE.getAxios().delete(submitUrl, params).then(() => {
                          this.$store.commit('showSnack', {
                            message: 'Löschen erfolgreich',
                            color: 'success'
                          });
                          this.close();
                          ametrasBtnEvent.buttonState.loading = false;
                          this.confirmationDialogConfig = null;
                        }, (error) => {
                          if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
                            this.$store.commit('showSnack', {
                              message: 'Löschen fehlgeschlagen',
                              color: 'error'
                            });
                          }
                          ametrasBtnEvent.buttonState.loading = false;
                          this.confirmationDialogConfig = null;
                        }).finally(() => {
                          this.confirmActionPending = false;
                        });
                      });
                    },
                    () => {
                      ametrasBtnEvent.buttonState.loading = false;
                      this.confirmationDialogConfig = null;
                      this.confirmActionPending = false;
                      // any further error is already handled within the corresponding request.
                    }
                );

              });
            }
          }, {
            text: 'Abbrechen',
            title: 'Abbrechen',
            disabled: false,
            loading: false,
            onClick: () => {
              ametrasBtnEvent.buttonState.loading = false;
              this.confirmationDialogConfig = null;
            }
          }],
          onEsc: () => {
            ametrasBtnEvent.buttonState.loading = false;
            this.confirmationDialogConfig = null;
          }
        };
        this.confirmationDialogConfigRerenderCounter ++;
        break;
    }
  }

  close() {
    const canClose = this.subMenu != null;
    if (canClose) {
      this.closeSubmenuDialog();
    } else {
      this.$emit('close');
    }
  }

  handleDialogButtonResponse(response: any, successMessage: string) {
    if (response.status !== 302) {
      if (response.data.closeAfterSuccess) {
        this.$emit('close');
      }

      const castedResponse = response.data as DisguiseDto.DialogParameterDto;
      if (castedResponse && castedResponse.event) {
        const eventType = castedResponse.event.type;
        switch (eventType) {
          case 'SAVE':
            this.$emit('save', castedResponse.event.payload);
            break;
          case 'CLOSE':
            this.$emit('close', castedResponse.event.payload);
          default:
            break;
        }
      }

      if (successMessage) {
        this.$store.commit('showSnack', {
          message: successMessage,
          color: 'success'
        });
      }
    } else {
      const castedResponse = response.data as DisguiseDto.RedirectDto;
      if (castedResponse) {
        if (castedResponse.optionalUserSuccessMessage) {
          this.$store.commit('showSnack', {
            message: castedResponse.optionalUserSuccessMessage,
            color: 'success'
          });
        }
        if (castedResponse.actionType && castedResponse.actionType['@type'] === 'SubMenuRedirectActionType') {
          if ((castedResponse.actionType.openInParentDepthIdx || 0) > 0) {
            this.$emit('subnaviinparent', castedResponse);
          } else {
            this.conditionalComponents.componentsByIdentifier = {};
            this.subMenu = {
              url: castedResponse.actionType.url || '',
              contextParameter: castedResponse.actionType.contextParameter,
              title: '',
              breadcrumbs: [],
              actionConfiguration: castedResponse.actionType
            };
          }
        }
      }
    }
  }

  /* Workaround for closing the menus without using v-model. */
  closeSubmenuDialog() {
    try {
      if (this.subMenu?.actionConfiguration) {
        for (const currentEvent of this.subMenu.actionConfiguration.events || []) {
          if (currentEvent.type === 'ReloadAfterCloseRedirectDto') {
            this.loadData();
          } else if (currentEvent.type === 'CloseAfterCloseRedirectDto') {
            this.$emit('close');
          }
        }
      }
    } finally {
      this.subMenu = null;
    }
  }

  /**
   * this is a replacement of the ametras buttons
   *
   * This is a required move, as the current ametras button is not implemented in a reusable and generic way.
   *
   * This is a restart.
   */
  onAmetrasAdvancedButtonClick(
      eventData: AmetrasAdvancedButtonEvent
  ) {
    if (eventData && eventData.buttonConfig && (eventData.buttonConfig as DisguiseDto.BasicFTAdvancedButtonDto).disableNotValid) {
      eventData.buttonConfig.loading = true;
      this.delayUntilPendingAffeRequestCountIsZeroAndFormularIsValid(() => {
        if (eventData && eventData.buttonConfig) {
          eventData.buttonConfig.loading = false;
        }
        this.onAmetrasAdvancedButtonClickPerformAction(eventData);
      }, () => {
        if (eventData && eventData.buttonConfig) {
          eventData.buttonConfig.loading = false;
        }
      });
    } else {
      this.onAmetrasAdvancedButtonClickPerformAction(eventData);
    }
  }

  triggerAdvancedButtonEvent(events: DisguiseDto.FTAdvancedButtonEventDtoUnion[]) {
    if (events) {
      for (const event of events) {
        if (event.type === 'FTAdvancedButtonPropagateGlobalEventDto') {
          GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.notifyListener(
              event.event || '',
              event.globalEventAction
          );
          if (event.optionalSuccessNotification) {
            this.$store.commit('showSnack', {
              message: event.optionalSuccessNotification.successMessage,
              color: 'success'
            });
          }
        } else if (event.type === 'FTAdvancedButtonSaveCloseAndRefreshEventDto') {
          this.triggerSaveCloseAndRefreshEvent(event);
        } else if (event.type === 'FTAdvancedButtonNoOpEventDto') {
          if (event.optionalSuccessNotification) {
            this.$store.commit('showSnack', {
              message: event.optionalSuccessNotification.successMessage,
              color: 'success'
            });
          }
        }
      }
    }
  }

  buildFieldEventListenerMap(
      fieldDefinition: ExtendedIFTRowElementUnion
  ): VueOnMapType {
    return FIELD_EVENTS_INSTANCE.buildPassthroughVueOnMapForAllEvents((eventName, eventArgs) => {
      this.$emit('content:' + eventName, {
        fieldDefinition: {...fieldDefinition},
        args: eventArgs
      });

      if (fieldDefinition.type === 'FTFieldDto') {
        const castedFieldType: ExtendedFTField = fieldDefinition as ExtendedFTField;
        castedFieldType.fieldEventSubject.next({
          eventName,
          eventArgs
        });
      }
      if (fieldDefinition.type === 'FTFieldDto' && eventName === 'input') {
        if (!this.instance.loading && fieldDefinition.readOnly !== true && fieldDefinition.disable !== true) {
          this.instance.dirty = true;
        }
        this.triggerSaveCloseAndRefreshEventIfConfigured(fieldDefinition);
      } else if (fieldDefinition.type === 'FTFieldDto' && eventName === 'selected') {
        this.$emit('selected', eventArgs);
      } else if (fieldDefinition.type === 'FTFieldDto' && eventName === 'change') {
        this.fieldStates[fieldDefinition.customReferenceName || fieldDefinition.fieldName || ''].value = eventArgs;
        if (this.formular) {
          fieldDefinition.value = eventArgs;
        }
      } else if (eventName === 'dirty') {
        if (!this.instance.loading) {
          this.instance.dirty = true;
        }
      } else if (fieldDefinition.type === 'FTFieldDto' && eventName === 'save') {
        const castedFieldDefinition = fieldDefinition as DisguiseDto.FTFieldDto;
        for (const currentEvent of castedFieldDefinition.eventsV2 || []) {
          if (currentEvent.type === 'SaveAfterSaveFTEventDto') {
            this.$emit('save', eventArgs);
          }
        }
      } else if (fieldDefinition.type === 'FTFieldDto' && eventName === 'update-context-parameter') {
        this.$emit('update-context-parameter', eventArgs);
      } else if (fieldDefinition.type === 'FTFieldDto' && eventName === 'check') {
        // expects callback within eventargs
        if (this.instance.input.checkConditions) {
          // 1. build input map
          const data: { [key: string]: any } = {};
          for (let rowIdx = 0; rowIdx < (this.instance.input.rows || []).length; rowIdx++) {
            const currentRow = (this.instance.input.rows || [])[rowIdx];
            if (currentRow['@type'] === 'FTRowDto') {
              for (const currentField of currentRow.fields || []) {
                if (currentField.type === 'FTFieldDto') {
                  if (currentField.uiType === 'LIST_TABLE' && currentField.typeSpecificSettings !== undefined && currentField.typeSpecificSettings['@type'] === 'TableListFieldSpecificSettingsV2') {
                    const castedTypeSpecificSettings = currentField.typeSpecificSettings as DisguiseDto.TableListFieldSpecificSettingsV2;
                    for (const currentSection of (castedTypeSpecificSettings.table || {}).sections || []) {
                      for (const currentSectionRow of currentSection.rows || []) {
                        for (const currentSectionRowCell of currentSectionRow.cells || []) {
                          for (const currentSectionRowCellFormularRow of (currentSectionRowCell.cellFormular || {}).rows || []) {
                            if (currentSectionRowCellFormularRow['@type'] === 'FTRowDto') {
                              for (const currentSectionRowCellFormularRowField of currentSectionRowCellFormularRow.fields || []) {
                                if (currentSectionRowCellFormularRowField.type === 'FTFieldDto' && currentSectionRowCellFormularRowField.customReferenceName !== undefined) {
                                  data[currentSectionRowCellFormularRowField.customReferenceName] = currentSectionRowCellFormularRowField.value;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  } else if (currentField.customReferenceName !== undefined) {
                    data[currentField.customReferenceName] = this.fieldStates[currentField.customReferenceName || currentField.fieldName || ''].value;
                  }
                }
              }
            } else if (currentRow['@type'] === 'FTGridDto') {
              for (const currentGridColumn of currentRow.columns || []) {
                for (const currentGridColumnRow of currentGridColumn.content || []) {
                  for (const currentField of currentGridColumnRow.fields || []) {
                    if (currentField.type === 'FTFieldDto') {
                      if (currentField.uiType === 'LIST_TABLE' && currentField.typeSpecificSettings !== undefined && currentField.typeSpecificSettings['@type'] === 'TableListFieldSpecificSettingsV2') {
                        const castedTypeSpecificSettings = currentField.typeSpecificSettings as DisguiseDto.TableListFieldSpecificSettingsV2;
                        for (const currentSection of (castedTypeSpecificSettings.table || {}).sections || []) {
                          for (const currentSectionRow of currentSection.rows || []) {
                            for (const currentSectionRowCell of currentSectionRow.cells || []) {
                              for (const currentSectionRowCellFormularRow of (currentSectionRowCell.cellFormular || {}).rows || []) {
                                if (currentSectionRowCellFormularRow['@type'] === 'FTRowDto') {
                                  for (const currentSectionRowCellFormularRowField of currentSectionRowCellFormularRow.fields || []) {
                                    if (currentSectionRowCellFormularRowField.type === 'FTFieldDto' && currentSectionRowCellFormularRowField.customReferenceName !== undefined) {
                                      data[currentSectionRowCellFormularRowField.customReferenceName] = currentSectionRowCellFormularRowField.value;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else if (currentField.customReferenceName !== undefined) {
                        data[currentField.customReferenceName] = this.fieldStates[currentField.customReferenceName || currentField.fieldName || ''].value;
                      }
                    }
                  }
                }
              }
            }
          }

          let violations = false;
          for (const currentCondition of this.instance.input.checkConditions) {
            if (currentCondition.jsonlogicExpr !== undefined) {
              try {
                const parsedDoc = JSON.parse(currentCondition.jsonlogicExpr);
                if (!apply(parsedDoc, data)) {
                  alert(currentCondition.violationMessage);
                  violations = true;
                  break;
                }
              } catch (e) {
                // if any error happens, ignore the whole block
              }
            }
          }
          if (!violations) {
            eventArgs();
          }
        } else {
          eventArgs();
        }
      }
      if (fieldDefinition.type === 'FTFieldDto' && fieldDefinition) {
        const castedFieldDefinition = fieldDefinition as DisguiseDto.FTFieldDto;
        for (const currentEvent of castedFieldDefinition.eventsV2 || []) {
          if (currentEvent.type === 'PassthroughEventFTEventDto') {
            if (currentEvent.eventName && currentEvent.eventName === eventName) {
              this.$emit(currentEvent.eventName, eventArgs);
            } else {
              throw new Error('Missing eventName');
            }
          }
        }
      }

    });
  }

  buildDialogEventListenerMap(formularDialog: DialogType): VueOnMapType {
    return FIELD_EVENTS_INSTANCE.buildPassthroughVueOnMapForAllEvents((eventName, eventArgs) => {
      let eventHandled = false;
      if (eventName === 'reloadParent') {
        this.loadData();
      } else if (eventName === 'subnaviinparent') {
        this.openSubNavi(eventArgs);
      } else if (eventName === 'closeDialog' && formularDialog.handleDialogCloseEventSeparately) {
        if (formularDialog.onCloseDialog) {
          formularDialog.onCloseDialog();
        }
        eventHandled = true;
      } else if (formularDialog.events) {
        for (const currentFormularEventConfig of formularDialog.events) {
          if (currentFormularEventConfig.type === 'OpenSubMenuAfterEventFTEventDto'
              && eventName === currentFormularEventConfig.eventName) {
            this.conditionalComponents.componentsByIdentifier = {};
            this.subMenu = {
              url: currentFormularEventConfig.url || '',
              title: '',
              breadcrumbs: [],
              contextParameter: eventArgs
            };
            if (formularDialog.onClose) {
              // opening a submenu must result in a close of the dialog
              formularDialog.onClose(eventArgs);
            }
            eventHandled = true;
          } else if (currentFormularEventConfig.type === 'PassthroughEventFTEventDto'
              && eventName === currentFormularEventConfig.eventName && (!currentFormularEventConfig.stopPropagationOnError || !eventArgs || !eventArgs.error)) {
            this.$emit(eventName, eventArgs);
          } else if (currentFormularEventConfig.type === 'ReloadAfterEventFTEventDto' && eventName === currentFormularEventConfig.eventName) {
            if (currentFormularEventConfig.closeInlineDialog) {
              if (formularDialog.onClose) {
                formularDialog.onClose(eventArgs);
              }
            }
            this.loadData();
          }
        }
      }
      if (!eventHandled && eventName === 'close') {
        if (!formularDialog.onClose) {
          this.emitClose(eventArgs);
        } else {
          formularDialog.onClose(eventArgs);
        }
      }
    });
  }

  private onAmetrasAdvancedButtonClickPerformAction(
      eventData: AmetrasAdvancedButtonEvent,
      additionalParams?: CompositeKeyType
  ) {
    return new Promise<void>((resolve, reject) => {
      if (eventData && eventData.buttonConfig && (eventData.buttonConfig as DisguiseDto.BasicFTAdvancedButtonDto)?.type === 'DialogWithFormularFTAdvancedButtonDto') {
        const castedConfig = eventData.buttonConfig as
            DisguiseDto.DialogWithFormularFTAdvancedButtonDto;

        // render as a dialog
        eventData.buttonConfig.loading = true;
        this.formularDialog = {
          formular: {
            'templateUrl': castedConfig.formularUrl || '',
            '@type': 'FORMULAR'
          },
          dialogTitle: castedConfig.dialogTitle,
          title: castedConfig.dialogTitle,
          create: castedConfig.create || false,
          widthPercentage: castedConfig.widthPercentage,
          maxWidthInPx: castedConfig.maxWidthInPx,
          canSubmit: true,
          onAbort: () => {
            if (castedConfig.events) {
              for (const event of castedConfig.events) {
                if (event.type === 'ReloadAfterCloseFTEventDto') {
                  this.loadData();
                }
              }
            }
            this.showFormularDialog = false;
            this.formularDialog = null;
            castedConfig.loading = false;
            reject();
          },
          events: castedConfig.events,
          onClose: (closeArgs: FormularCloseEventData) => {
            if (castedConfig.events) {
              for (const event of castedConfig.events) {
                if (event.type === 'ReloadAfterCloseFTEventDto') {
                  this.loadData();
                }
                if (event.type === 'PassthroughEventFTEventDto' && event.eventName === 'close' && (!event.stopPropagationOnError || !closeArgs || !closeArgs.error)) {
                  this.emitClose(closeArgs);
                }
              }
            }
            this.showFormularDialog = false;
            this.formularDialog = null;
            castedConfig.loading = false;
            resolve();
          },
          onCloseDialog: () => {
            this.showFormularDialog = false;
            this.formularDialog = null;
            castedConfig.loading = false;
            resolve();
          },
          handleDialogCloseEventSeparately: castedConfig.handleDialogCloseEventSeparately
        };
        castedConfig.loading = false;
        this.showFormularDialog = true;

      } else if (eventData.buttonConfig && (eventData.buttonConfig as DisguiseDto.BasicFTAdvancedButtonDto)?.type === 'ConfirmButtonFTAdvancedButtonDto') {
        const castedConfig = eventData.buttonConfig as DisguiseDto.ConfirmButtonFTAdvancedButtonDto;
        castedConfig.loading = true;
        if (castedConfig.url) {
          this.executeDialogCtrl({
            url: castedConfig.url,
            dialogId: castedConfig.defaultDialogId || 0,
            urlParameters: [],
            promtInput: '',
            buttonState: castedConfig,
            eventData: castedConfig.buttonEvents || []
          });
          resolve();
        } else {
          reject();
          throw new Error('URL must be specified for dialog handling.');
        }
      } else if (eventData.buttonConfig && (eventData.buttonConfig as DisguiseDto.BasicFTAdvancedButtonDto)?.type === 'CallApiFTAdvancedButtonDto') {
        const config = eventData.buttonConfig as DisguiseDto.CallApiFTAdvancedButtonDto;
        if ('GET_NEW_TAB' === config.httpMethod) {
          window.open(config.url || '', '_blank');
          resolve();
          if (config.optionalSuccessNotification) {
            this.$store.commit('showSnack', {
              message: config.optionalSuccessNotification.successMessage,
              color: 'success'
            });
          }
          this.triggerAdvancedButtonEvent((eventData.buttonConfig as DisguiseDto.BasicFTAdvancedButtonDto)?.buttonEvents || []);
        } else {
          config.loading = true;
          HTTP_SERVICE_INSTANCE.getAxios().request({
            url: config.url || '',
            method: config.httpMethod || 'GET',
            params: additionalParams
          }).then(() => {
            config.loading = false;
            resolve();
            if (config.optionalSuccessNotification) {
              this.$store.commit('showSnack', {
                message: config.optionalSuccessNotification.successMessage,
                color: 'success'
              });
            }
            this.triggerAdvancedButtonEvent((eventData.buttonConfig as DisguiseDto.BasicFTAdvancedButtonDto)?.buttonEvents || []);
          }, (error) => {
            reject();
            config.loading = false;
            if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
              if (error.response.data['@type'] === 'DisguiseBusinessExceptionConfirmationDialogDto') {
                const castedResponse = error.response.data as DisguiseDto.DisguiseBusinessExceptionConfirmationDialogDto;

                const confirmationDialogConfig: ConfirmationDialogConfig = {
                  title: castedResponse.title || '',
                  headerColor: 'primary',
                  message: castedResponse.message || '',
                  onEsc: () => {
                    this.confirmationDialogConfig = null;
                  },
                  buttons: []
                };

                if (castedResponse.confirmButtonText) {
                  confirmationDialogConfig.buttons.push({
                    text: castedResponse.confirmButtonText || '',
                    title: castedResponse.confirmButtonTitle || '',
                    disabled: false,
                    loading: false,
                    autoFocus: true,
                    onClick: (button: ConfirmationDialogButton, event, formularInstance) => {
                      if (castedResponse.confirmButtonAction) {

                        const confirmUrl = castedResponse.confirmButtonAction['@type'] === 'ConfirmationDialogUrlAction' ?
                            (castedResponse.confirmButtonAction as DisguiseDto.ConfirmationDialogUrlActionDto).url : '';

                        button.loading = true;
                        if (formularInstance) {
                          formularInstance.serializeFormularElementValues().then((formularParameters) => {
                            this.onAmetrasAdvancedButtonClickPerformAction({
                              buttonConfig: ({
                                ...config,
                                url: (confirmUrl || '')
                              }) as DisguiseDto.CallApiFTAdvancedButtonDto
                            }, {
                              ...(additionalParams || {}),
                              ...formularParameters
                            }).then(() => {
                              this.confirmationDialogConfig = null;
                            }, () => {
                              this.$store.commit('showSnack', {
                                message: 'Speichern fehlgeschlagen',
                                color: 'error'
                              });
                              button.loading = false;
                            });
                          }, () => {
                            button.loading = false;
                          });
                        } else {
                          this.onAmetrasAdvancedButtonClickPerformAction(
                              {
                                buttonConfig: ({
                                  ...config,
                                  url: (confirmUrl || '')
                                }) as DisguiseDto.CallApiFTAdvancedButtonDto
                              },
                              {
                                ...(additionalParams || {}),
                              }).then(() => {
                            this.confirmationDialogConfig = null;
                          }, () => {
                            this.$store.commit('showSnack', {
                              message: 'Speichern fehlgeschlagen',
                              color: 'error'
                            });
                            button.loading = false;
                          });
                        }
                      } else {
                        this.confirmationDialogConfig = null;
                      }
                    }
                  });
                }
                if (castedResponse.abortButtonText) {
                  confirmationDialogConfig.buttons.push({
                    text: castedResponse.abortButtonText || '',
                    title: castedResponse.abortButtonTitle || '',
                    disabled: false,
                    loading: false,
                    onClick: () => {
                      this.confirmationDialogConfig = null;
                    }
                  });
                }

                this.confirmationDialogConfig = confirmationDialogConfig;
                this.confirmationDialogConfigRerenderCounter++;
              } else if (error.response.data['@type'] === 'DisguiseBusinessExceptionDialogDto') {
                const castedResponse = error.response.data as DisguiseDto.DisguiseBusinessExceptionDialogDto;

                const confirmationDialogConfig: ConfirmationDialogConfig = {
                  title: castedResponse.title || '',
                  headerColor: 'primary',
                  message: castedResponse.message || '',
                  onEsc: () => {
                    this.confirmationDialogConfig = null;
                  },
                  buttons: []
                };

                for ( const responseButton of (castedResponse.buttons || [])) {
                  confirmationDialogConfig.buttons.push({
                    text: responseButton.text || '',
                    title: responseButton.title || '',
                    disabled: false,
                    loading: false,
                    autoFocus: responseButton.autoFocus || false,
                    onClick: (button: ConfirmationDialogButton, event, formularInstance) => {
                      if (responseButton && responseButton.action) {

                        const confirmUrl = responseButton.action['@type'] === 'DisguiseDialogUrlAction' ?
                            (responseButton.action as DisguiseDto.DisguiseDialogUrlActionDto).url : '';

                        button.loading = true;
                        if (formularInstance) {
                          formularInstance.serializeFormularElementValues().then((formularParameters) => {
                            this.onAmetrasAdvancedButtonClickPerformAction({
                              buttonConfig: ({
                                ...config,
                                url: (confirmUrl || '')
                              }) as DisguiseDto.CallApiFTAdvancedButtonDto
                            }, {
                              ...(additionalParams || {}),
                              ...formularParameters
                            }).then(() => {
                              this.confirmationDialogConfig = null;
                            }, () => {
                              this.$store.commit('showSnack', {
                                message: 'Speichern fehlgeschlagen',
                                color: 'error'
                              });
                              button.loading = false;
                            });
                          }, () => {
                            button.loading = false;
                          });
                        } else {
                          this.onAmetrasAdvancedButtonClickPerformAction(
                              {
                                buttonConfig: ({
                                  ...config,
                                  url: (confirmUrl || '')
                                }) as DisguiseDto.CallApiFTAdvancedButtonDto
                              },
                              {
                                ...(additionalParams || {}),
                              }).then(() => {
                            this.confirmationDialogConfig = null;
                          }, () => {
                            this.$store.commit('showSnack', {
                              message: 'Speichern fehlgeschlagen',
                              color: 'error'
                            });
                            button.loading = false;
                          });
                        }
                      } else {
                        this.confirmationDialogConfig = null;
                      }
                    }
                  });
                }
                this.confirmationDialogConfig = confirmationDialogConfig;
                this.confirmationDialogConfigRerenderCounter++;
              } else {
                if (config.optionalSuccessNotification) {
                  this.$store.commit('showSnack', {
                    message: config.optionalSuccessNotification.errorMessage,
                    color: 'error'
                  });
                } else {
                  this.$store.commit('showSnack', {
                    message: 'Operation fehlgeschlagen',
                    color: 'error'
                  });
                }
              }
            }
          });
        }
      } else if (eventData.buttonConfig
          && (eventData.buttonConfig as DisguiseDto.BasicFTAdvancedButtonDto)?.type === 'BasicFTAdvancedButtonDto'
          && (eventData.buttonConfig as DisguiseDto.BasicFTAdvancedButtonDto).buttonEvents
      ) {
        this.triggerAdvancedButtonEvent((eventData.buttonConfig as DisguiseDto.BasicFTAdvancedButtonDto)?.buttonEvents || []);
        resolve();
      } else {
        reject();
      }
    });
  }

  private bindToReload() {
    if (this.userRequestedReloadSubscription) {
      this.userRequestedReloadSubscription.unsubscribe();
    }
    if (this.userRequestedReload) {
      this.userRequestedReloadSubscription = this.userRequestedReload.subscribe((reqId) => {
        if (this.initialDataLoaded) { // ever loaded data
          if (this.reloadOnUserRequest && this.lastUserRequestedReloadReqId !== reqId) {
            this.lastUserRequestedReloadReqId = reqId;
            this.loadData();
          }
        }
      });
    }
  }

  private triggerSaveCloseAndRefreshEvent(
      currentEvent: DisguiseDto.SaveCloseAndRefreshFTEventDto | DisguiseDto.FTAdvancedButtonSaveCloseAndRefreshEventDto
  ) {
    this.executeOptionalUserConfirmationAndThenCb(currentEvent, (
            event: DisguiseDto.FTEventV2Dto | DisguiseDto.FTAdvancedButtonEventDto,
            resetDialogButtons: () => void
        ) => {
          const saveRequestOptions: SaveRequestType = {
            eventUrl: currentEvent.eventUrl || '',
            success: () => {
              this.emitClose({forceReload: true});
              this.confirmationDialogConfig = null;
              if (event.optionalSuccessNotification) {
                this.$store.commit('showSnack', {
                  message: event.optionalSuccessNotification.successMessage,
                  color: 'success'
                });
              }
            }, error: (response: any) => {
              if (!(response instanceof DisguiseBusinessExceptionWrapper)) {
                if (event.optionalSuccessNotification) {
                  this.$store.commit('showSnack', {
                    message: event.optionalSuccessNotification.errorMessage,
                    color: 'error'
                  });
                }
              }
              resetDialogButtons();
            }
          };
          this.save(saveRequestOptions.eventUrl).then((response) => {
            saveRequestOptions.success(response);
          }, (response) => {
            saveRequestOptions.error(response);
          });
        }
    );
  }

  private executeDialogCtrl(dialogControlConfiguration: AmetrasDialogCtrlConfiguration) {
    const params: CompositeKeyType = this.buildApiCallParameters();
    for (const parameter of dialogControlConfiguration.urlParameters || []) {
      set(params, parameter.parameter || '', parameter.value || '');
    }
    let eventUrl = dialogControlConfiguration.url + (dialogControlConfiguration.url.indexOf('?') > -1 ? '&' : '?')
        + 'dialogId' + '=' + dialogControlConfiguration.dialogId;
    eventUrl += dialogControlConfiguration.promtInput ? '&promtInput=' + dialogControlConfiguration.promtInput : '';

    this.$nextTick(() => {
      // wait until AFFE created the necessary requests by waiting for next tick


      SUBJECT_UTILS_INSTANCE.delayUntilSubjectMatchesFilterConditionOnce(
          this.pendingAFFERequestCount,
          (currentCount) => currentCount === 0,
          () => {
            this.$nextTick(() => {
              // wait until AFFE updated the data based on results by waiting for next tick

              HTTP_SERVICE_INSTANCE.getAxios().post(eventUrl, params).then((response) => {
                if (!response.data.done) {
                  switch (response.data.dialogType) {
                    case 'PROMT_DIALOG':
                      this.$refs.promt.open('Achtung',
                          response.data.dialogMessage).then(
                          (input: string) => {
                            dialogControlConfiguration.dialogId = response.data.dialogConfirmedId;
                            dialogControlConfiguration.promtInput = input;
                            this.executeDialogCtrl(dialogControlConfiguration);
                          });
                      break;
                    case 'ALERT_DIALOG':
                      this.$refs.alert.open('Achtung',
                          [response.data.dialogMessage]).then(() => {
                        dialogControlConfiguration.dialogId = response.data.dialogConfirmedId;
                        this.executeDialogCtrl(dialogControlConfiguration);
                      });
                      break;
                    case 'CONFIRM_DIALOG':
                      this.confirmationDialogConfig = {
                        title: 'Bestätigen',
                        headerColor: 'primary',
                        message: response.data.dialogMessage || '',
                        closeButton: {
                          onClick: () => {
                            dialogControlConfiguration.buttonState.loading = false;
                            this.confirmationDialogConfig = null;
                          }
                        },
                        buttons: [{
                          text: response.data.confirmButtonTitle || 'Bestätigen',
                          title: response.data.confirmButtonTitle || 'Bestätigen',
                          disabled: false,
                          loading: false,
                          autoFocus: true,
                          onClick: () => {
                            dialogControlConfiguration.dialogId = response.data.dialogConfirmedId;
                            this.executeDialogCtrl(dialogControlConfiguration);
                            this.confirmationDialogConfig = null;
                          }
                        }, {
                          text: response.data.abortButtonTitle || 'Abbrechen',
                          title: response.data.abortButtonTitle || 'Abbrechen',
                          disabled: false,
                          loading: false,
                          onClick: () => {
                            dialogControlConfiguration.dialogId = response.data.dialogAbortId;
                            this.executeDialogCtrl(dialogControlConfiguration);
                            this.confirmationDialogConfig = null;
                          }
                        }],
                        onEsc: () => {
                          dialogControlConfiguration.buttonState.loading = false;
                          this.confirmationDialogConfig = null;
                        }
                      };
                      this.confirmationDialogConfigRerenderCounter ++;
                      break;
                    default:
                      break;
                  }
                } else {
                  dialogControlConfiguration.buttonState.loading = false;
                }
                this.instance.dirty = false;
                if (response.data.jumpToDifferentTab) {
                  this.$emit('switchsubmenu', response.data.naviIdOfTab);
                }
                if (response.data.success || response.status === 302) {
                  this.handleDialogButtonResponse(response, response.data.successMessage);
                  dialogControlConfiguration.buttonState.loading = false;
                  if (response.data.reloadDataAfterSuccess) {
                    this.loadData();
                  }
                  if (response.data.reloadParentForm) {
                    this.$emit('reloadParent');
                  }
                  if (response.data.openDialogAfterSuccess) {
                    this.showFormularDialog = true;
                    this.formularDialog = {
                      create: true,
                      formular: {
                        'templateUrl': response.data.dialogTemplateUrl || '',
                        '@type': 'FORMULAR'
                      },
                      editKey: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(response.data.dtUrlParameterDtoList),
                      dialogTitle: response.data.dialogTitle,
                      title: response.data.dialogTitle,
                      canSubmit: response.data.dialogCanSubmit,
                      onAbort: () => {
                        dialogControlConfiguration.buttonState.loading = false;
                        this.showFormularDialog = false;
                        this.formularDialog = null;
                      }
                    };
                  }
                  this.triggerAdvancedButtonEvent(dialogControlConfiguration.eventData);
                }
              }, (error) => {
                if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
                  if (error.response.data['@type'] === 'DisguiseBusinessExceptionConfirmationDialogDto') {
                    const castedResponse = error.response.data as DisguiseDto.DisguiseBusinessExceptionConfirmationDialogDto;

                    const confirmationDialogConfig: ConfirmationDialogConfig = {
                      title: castedResponse.title || '',
                      headerColor: 'primary',
                      message: castedResponse.message || '',
                      onEsc: () => {
                        this.confirmationDialogConfig = null;
                        dialogControlConfiguration.buttonState.loading = false;
                      },
                      buttons: []
                    };

                    if (castedResponse.confirmButtonText) {
                      confirmationDialogConfig.buttons.push({
                        text: castedResponse.confirmButtonText || '',
                        title: castedResponse.confirmButtonTitle || '',
                        disabled: false,
                        loading: false,
                        autoFocus: true,
                        onClick: (button: ConfirmationDialogButton) => {
                          if (castedResponse.confirmButtonAction) {
                            const confirmUrl = castedResponse.confirmButtonAction['@type'] === 'ConfirmationDialogUrlAction' ?
                                (castedResponse.confirmButtonAction as DisguiseDto.ConfirmationDialogUrlActionDto).url : '';
                            button.loading = true;
                            dialogControlConfiguration.url = confirmUrl || '';
                            this.executeDialogCtrl(dialogControlConfiguration);
                            this.confirmationDialogConfig = null;
                          } else {
                            this.confirmationDialogConfig = null;
                          }
                        }
                      });
                    }

                    if (castedResponse.abortButtonText) {
                      confirmationDialogConfig.buttons.push({
                        text: castedResponse.abortButtonText || '',
                        title: castedResponse.abortButtonTitle || '',
                        disabled: false,
                        loading: false,
                        onClick: () => {
                          this.confirmationDialogConfig = null;
                          dialogControlConfiguration.buttonState.loading = false;
                        }
                      });
                    }
                    this.confirmationDialogConfig = confirmationDialogConfig;
                    this.confirmationDialogConfigRerenderCounter ++;
                  } else if (error.response.data['@type'] === 'DisguiseBusinessExceptionDialogDto') {
                    const castedResponse = error.response.data as DisguiseDto.DisguiseBusinessExceptionDialogDto;

                    const confirmationDialogConfig: ConfirmationDialogConfig = {
                      title: castedResponse.title || '',
                      headerColor: 'primary',
                      message: castedResponse.message || '',
                      onEsc: () => {
                        this.confirmationDialogConfig = null;
                        dialogControlConfiguration.buttonState.loading = false;
                      },
                      buttons: []
                    };

                    for (const responseButton of (castedResponse.buttons || [])) {
                      confirmationDialogConfig.buttons.push({
                        text: responseButton.text || '',
                        title: responseButton.title || '',
                        disabled: false,
                        loading: false,
                        autoFocus: responseButton.autoFocus || false,
                        onClick: (button: ConfirmationDialogButton) => {
                          if (responseButton && responseButton.action) {
                            const confirmUrl = responseButton.action['@type'] === 'DisguiseDialogUrlAction' ?
                                (responseButton.action as DisguiseDto.DisguiseDialogUrlActionDto).url : '';
                            button.loading = true;
                            dialogControlConfiguration.url = confirmUrl || '';
                            this.executeDialogCtrl(dialogControlConfiguration);
                            this.confirmationDialogConfig = null;
                          } else {
                            this.confirmationDialogConfig = null;
                          }
                        }
                      });
                    }

                    this.confirmationDialogConfig = confirmationDialogConfig;
                    this.confirmationDialogConfigRerenderCounter ++;
                  } else {
                    this.$store.commit('showSnack', {
                      message: 'Speichern fehlgeschlagen',
                      color: 'error'
                    });
                    dialogControlConfiguration.buttonState.loading = false;
                  }
                }
              });

            });
          },
          () => {
            // any further error is already handled within the corresponding request.
          }
      );
    });
  }

  private detachKeyListener() {
    window.removeEventListener('keydown', this.keyPressed);
  }

  private attachKeyListener() {
    window.addEventListener('keydown', this.keyPressed);
  }

  private keyPressed(event: KeyboardEvent) {
    if (event.key === 'Escape') { // ESC
      this.confirmLosingChanges();
    }
  }

  /**
   * Overwrites fields
   * @param rows the rows to modify
   */
  private overwriteFields<T>(rows: DisguiseDto.IFormularContent[], clear: boolean = false) {
    if (clear || (this.overwrittenFields && Object.keys(this.overwrittenFields).length)) {
      for (const currentContent of rows || []) {
        if (currentContent['@type'] === 'FTRowDto') {
          const castedRow = currentContent as DisguiseDto.FTRowDto;
          for (const currentField of castedRow.fields || []) {
            if (currentField.type === 'FTFieldDto') {
              const overwrittenFieldValue = this.overwrittenFields[currentField.fieldName || ''];
              if (overwrittenFieldValue) {
                currentField.value = overwrittenFieldValue.value;
                if (overwrittenFieldValue.selectValues) {
                  currentField.selectValues = overwrittenFieldValue.selectValues;
                }
              } else if (clear) {
                currentField.value = '';
                currentField.selectValues = [];
              }
            } else if (currentField.type === 'FTSearchFieldGroup') {
              const fieldGroup = currentField as DisguiseDto.FTSearchFieldGroup;
              for (const currentSearchField of fieldGroup.searchFields || []) {
                const overwrittenFieldValue =
                    this.overwrittenFields[currentSearchField.fieldName || ''];
                if (overwrittenFieldValue) {
                  currentSearchField.value = overwrittenFieldValue.value;
                } else if (clear) {
                  currentSearchField.value = '';
                }
              }
              for (const currentLabelField of fieldGroup.labelFields || []) {
                const overwrittenFieldValue =
                    this.overwrittenFields[currentLabelField.fieldName || ''];
                if (overwrittenFieldValue) {
                  currentLabelField.value = overwrittenFieldValue.value;
                } else if (clear) {
                  currentLabelField.value = '';
                }
              }
            }
          }
        } else if (currentContent['@type'] === 'FTGridDto') {
          for (const currentGridColumn of (currentContent as DisguiseDto.FTGridDto).columns || []) {
            for (const currentGridColumnRow of currentGridColumn.content || []) {

              const castedRow = currentGridColumnRow as DisguiseDto.FTRowDto;
              for (const currentField of castedRow.fields || []) {
                if (currentField.type === 'FTFieldDto') {
                  const overwrittenFieldValue = this.overwrittenFields[currentField.fieldName || ''];
                  if (overwrittenFieldValue) {
                    currentField.value = overwrittenFieldValue.value;
                    currentField.selectValues = overwrittenFieldValue.selectValues;
                  } else if (clear) {
                    currentField.value = '';
                    currentField.selectValues = [];
                  }
                } else if (currentField.type === 'FTSearchFieldGroup') {
                  const fieldGroup = currentField as DisguiseDto.FTSearchFieldGroup;
                  for (const currentSearchField of fieldGroup.searchFields || []) {
                    const overwrittenFieldValue =
                        this.overwrittenFields[currentSearchField.fieldName || ''];
                    if (overwrittenFieldValue) {
                      currentSearchField.value = overwrittenFieldValue.value;
                    } else if (clear) {
                      currentSearchField.value = '';
                    }
                  }
                  for (const currentLabelField of fieldGroup.labelFields || []) {
                    const overwrittenFieldValue =
                        this.overwrittenFields[currentLabelField.fieldName || ''];
                    if (overwrittenFieldValue) {
                      currentLabelField.value = overwrittenFieldValue.value;
                    } else if (clear) {
                      currentLabelField.value = '';
                    }
                  }
                }
              }

            }
          }
        }
      }
    }
  }

  private buildApiCallParameters() {
    const params: CompositeKeyType = {...this.primaryKey};
    for (const staticProp of this.instance.input.staticProps || []) {
      if (staticProp.value && staticProp.path) {
        set(params, staticProp.path, staticProp.value);
      }
    }
    if (this.instance.input.rows) {
      for (let currentRowIndex = 0; currentRowIndex < (this.instance.input.rows || []).length; currentRowIndex++) {
        const currentContent = this.instance.input.rows[currentRowIndex];
        if (currentContent['@type'] === 'FTRowDto') {
          const castedRow = currentContent as DisguiseDto.FTRowDto;
          if (castedRow && castedRow.fields) {
            for (let currentFieldIndex = 0; currentFieldIndex < (castedRow.fields || []).length; currentFieldIndex++) {
              const field = castedRow.fields[currentFieldIndex];
              if (field) {
                if ((field.type === 'FTFieldDto')) {
                  if ((field.fieldName || field.endpointKeyPath)
                      && field.uiType
                      && FormTemplate.UI_TYPES_WITHOUT_VALUE.indexOf(field.uiType) < 0) {
                    this.addFieldToParams(
                        (field as DisguiseDto.FTFieldDto),
                        params
                    );
                  }
                } else {
                  for (const sField of (field as DisguiseDto.FTSearchFieldGroup).searchFields || []) {
                    this.addFieldToParams(sField, params);
                  }
                  for (const lField of (field as DisguiseDto.FTSearchFieldGroup).labelFields || []) {
                    if (!lField.disable) { // write label fields to url if they are editable
                      this.addFieldToParams(lField, params);
                    }
                  }
                }
              }
            }
          }
        } else if (currentContent['@type'] === 'FTGridDto') {
          for (const currentGridColumn of (currentContent as DisguiseDto.FTGridDto).columns || []) {
            for (const currentGridColumnRow of currentGridColumn.content || []) {

              const castedRow = currentGridColumnRow as DisguiseDto.FTRowDto;
              if (castedRow && castedRow.fields) {
                for (let currentFieldIndex = 0; currentFieldIndex < (castedRow.fields || []).length; currentFieldIndex++) {
                  const field = castedRow.fields[currentFieldIndex];
                  if (field) {
                    if ((field.type === 'FTFieldDto')) {
                      if ((field.fieldName || field.endpointKeyPath)
                          && field.uiType
                          && FormTemplate.UI_TYPES_WITHOUT_VALUE.indexOf(field.uiType) < 0) {
                        this.addFieldToParams(
                            (field as DisguiseDto.FTFieldDto),
                            params
                        );
                      }
                    } else {
                      for (const sField of (field as DisguiseDto.FTSearchFieldGroup).searchFields || []) {
                        this.addFieldToParams(sField, params);
                      }
                      for (const lField of (field as DisguiseDto.FTSearchFieldGroup).labelFields || []) {
                        if (!lField.disable) { // write label fields to url if they are editable
                          this.addFieldToParams(lField, params);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return params;
  }

  private buildApiCallUrlPrefix() {
    let result = `${this.formularConfig.entityUrl}`;
    if (this.instance.input.submitURL) {
      result = `${this.instance.input.submitURL}`;
    }
    return result;
  }

  private addAdvancedFieldFunctions(initialInit: boolean) {
    if (this.instance.input.functionConfig && !this.fieldFunctionConfiguration) {
      this.fieldFunctionConfiguration = new AdvancedFieldFunctionConfiguration(
          this.instance.input.functionConfig,
          this.conditionalComponents,
          this.changeContextParam,
          this.triggerConditionalComponentEvent,
          this.handleBusinessException,
          (count) => {
            this.pendingAFFERequestCount.next(count);
          }
      );
      // builds advanced field functions, if not already initialized
      this.$nextTick(() => {
        if (this.fieldFunctionConfiguration) {
          for (const currentFieldFunction
              of this.instance.input.functionConfig?.advancedFieldFunctions || []) {
            // build new function executor
            const functionExecutor =
                this.fieldFunctionConfiguration.bindNewFieldFunctionExecutor(currentFieldFunction);

            for (const currentFieldReferenceDescription
                of currentFieldFunction.fieldReferenceDescriptions || []) {
              if (currentFieldReferenceDescription) {
                if (currentFieldReferenceDescription['@type'] === 'FTFieldReferenceDescription') {
                  const castedCurrentFieldReferenceDescription = currentFieldReferenceDescription as
                      DisguiseDto.FTFieldReferenceDescription;

                  if (castedCurrentFieldReferenceDescription.referenceName !== undefined) {
                    const fieldRef = this.lookupFieldReference(castedCurrentFieldReferenceDescription.referenceName || '');
                    let modelValueFound: boolean = false;
                    if (this.instance.input.rows) {
                      for (let currentRowIndex = 0;
                           currentRowIndex < (this.instance.input.rows || []).length;
                           currentRowIndex++) {
                        const currentContent = this.instance.input.rows[currentRowIndex];
                        if (currentContent['@type'] === 'FTRowDto') {
                          const castedRow = currentContent as DisguiseDto.FTRowDto;

                          if (castedRow && castedRow.fields) {
                            for (let currentFieldIndex = 0;
                                 currentFieldIndex < (castedRow.fields || []).length;
                                 currentFieldIndex++) {
                              const currentField = castedRow.fields[currentFieldIndex];
                              if (currentField && currentField.type === 'FTFieldDto' &&
                                  (currentField.customReferenceName || currentField.fieldName) ===
                                  castedCurrentFieldReferenceDescription.referenceName) {

                                // we are binding here a common field
                                functionExecutor.bindNewFieldStateExecutor(
                                    fieldRef,
                                    castedCurrentFieldReferenceDescription,
                                    this.fieldStates[currentField.customReferenceName || currentField.fieldName || ''],
                                    (currentField as ExtendedFTField).fieldEventSubject
                                );

                                modelValueFound = true;
                                break;
                              }
                            }
                          }
                        } else if (currentContent['@type'] === 'FTGridDto') {
                          for (const currentGridColumn of (currentContent as DisguiseDto.FTGridDto).columns || []) {
                            for (const currentGridColumnRow of currentGridColumn.content || []) {

                              const castedRow = currentGridColumnRow as DisguiseDto.FTRowDto;

                              if (castedRow && castedRow.fields) {
                                for (let currentFieldIndex = 0;
                                     currentFieldIndex < (castedRow.fields || []).length;
                                     currentFieldIndex++) {
                                  const currentField = castedRow.fields[currentFieldIndex];
                                  if (currentField && currentField.type === 'FTFieldDto' &&
                                      (currentField.customReferenceName || currentField.fieldName) ===
                                      castedCurrentFieldReferenceDescription.referenceName) {

                                    // we are binding here a common field
                                    functionExecutor.bindNewFieldStateExecutor(
                                        fieldRef,
                                        castedCurrentFieldReferenceDescription,
                                        this.fieldStates[currentField.customReferenceName || currentField.fieldName || ''],
                                        (currentField as ExtendedFTField).fieldEventSubject
                                    );

                                    modelValueFound = true;
                                    break;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    if (!modelValueFound) {
                      throw new Error(
                          'Model value lookup for AdvancedFieldFunctionExecutor failed.'
                      );
                    }
                  }
                } else if (currentFieldReferenceDescription['@type'] === 'AdvancedButtonReferenceDescription') {
                  if (currentFieldReferenceDescription.id) {
                    const buttonRef = (this.$refs as any)[currentFieldReferenceDescription.id];
                    if (buttonRef) {
                      let finalButtonRef = buttonRef;
                      if (Array.isArray(finalButtonRef)) {
                        finalButtonRef = finalButtonRef[0];
                      }
                      functionExecutor.bindNewButtonStateExecutor(
                          finalButtonRef as Vue,
                          currentFieldReferenceDescription,
                          this.buttonStates[currentFieldReferenceDescription.id || ''],
                      );
                    } else {
                      throw new Error(
                          `Button lookup for AdvancedButtonReferenceDescription failed. id: ${currentFieldReferenceDescription.id}`
                      );
                    }
                  } else {
                    throw new Error(
                        'Wrong field configuration.'
                    );
                  }
                }
              }
            }

            for (const currentContextReferenceDescription
                of currentFieldFunction.contextFieldReferenceDescriptions || []) {
              if (currentContextReferenceDescription.contextKeyPath) {
                const contextParamValue = this.primaryKey[currentContextReferenceDescription.contextKeyPath];
                if (contextParamValue === undefined) {
                  throw new Error(
                      'context param value lookup for AdvancedFieldFunctionExecutor failed for keyPath: ' + currentContextReferenceDescription.contextKeyPath
                  );
                }
                functionExecutor.bindNewStaticContextField(
                    currentContextReferenceDescription,
                    contextParamValue
                );
              }
            }
          }
          this.fieldFunctionConfiguration.afterInit();
          if (!initialInit) {
            this.fieldFunctionConfiguration.afterReInit();
          }
        }
      });
    }
  }

  private triggerConditionalComponentEvent(
      nativeActionConfiguration: DisguiseDto.INativeEventConfigurationUnion,
      eventData: any
  ) {
    throw new Error('Unsupported native action configuration');
  }

  private handleBusinessException(errorResponse: AxiosResponse) {
    if (errorResponse.data['@type'] === 'DisguiseBusinessExceptionConfirmationDialogDto') {
      const castedResponse = errorResponse.data as DisguiseDto.DisguiseBusinessExceptionConfirmationDialogDto;
      this.createAndDisplayConfirmationDialog(castedResponse);
    } else if (errorResponse.data['@type'] === 'DisguiseBusinessExceptionDialogDto') {
      const castedResponse = errorResponse.data as DisguiseDto.DisguiseBusinessExceptionDialogDto;
      this.createAndDisplayDynamicDialog(castedResponse);
    }
  }

  private createAndDisplayConfirmationDialog(castedConfirmationDialog: DisguiseDto.DisguiseBusinessExceptionConfirmationDialogDto) {
    const confirmationDialogConfig: ConfirmationDialogConfig = {
      title: castedConfirmationDialog.title || '',
      headerColor: 'primary',
      message: castedConfirmationDialog.message || '',
      onEsc: () => {
        if (castedConfirmationDialog.escapeAction) {
          this.handleConfirmationDialogEvents(castedConfirmationDialog.escapeAction);
        }
        this.confirmationDialogConfig = null;
      },
      buttons: [],
      formular: castedConfirmationDialog.formular
    };

    if (castedConfirmationDialog.confirmButtonTitle || castedConfirmationDialog.confirmButtonText) {
      confirmationDialogConfig.buttons.push({
        text: castedConfirmationDialog.confirmButtonText || '',
        title: castedConfirmationDialog.confirmButtonTitle || '',
        disabled: false,
        loading: false,
        autoFocus: true,
        onClick: (button: ConfirmationDialogButton, event, formularInstance) => {
          // synchroner Doppelklick-Schutz (analog case 'DELETE').
          if (this.confirmActionPending) {
            return;
          }
          this.confirmActionPending = true;
          button.loading = true;
          this.confirmationDialogConfigRerenderCounter++;

          if (formularInstance) {
            formularInstance.serializeFormularElementValues().then((formularParameters) => {

              const confirmUrl = castedConfirmationDialog.confirmButtonAction ?
                  (castedConfirmationDialog.confirmButtonAction as DisguiseDto.ConfirmationDialogUrlActionDto).url
                  : '';
              HTTP_SERVICE_INSTANCE.getAxios().post(
                  this.buildRestURL((confirmUrl || ''))).then(() => {
                this.confirmationDialogConfig = null;
              }, () => {
                button.loading = false;
              }).finally(() => {
                this.confirmActionPending = false;
              });
            }, () => {
              button.loading = false;
              this.confirmActionPending = false;
            });
          } else {
            if (castedConfirmationDialog.confirmButtonAction) {
              if (castedConfirmationDialog.confirmButtonAction['@type'] === 'ConfirmationDialogUrlAction') {
                const castedConfirmButtonUrlAction = castedConfirmationDialog.confirmButtonAction as DisguiseDto.ConfirmationDialogUrlActionDto;
                HTTP_SERVICE_INSTANCE.getAxios().post(
                    this.buildRestURL(castedConfirmButtonUrlAction.url || '')).then(() => {
                  this.confirmationDialogConfig = null;
                }, () => {
                  button.loading = false;
                }).finally(() => {
                  this.confirmActionPending = false;
                });
              } else {
                this.handleConfirmationDialogEvents(castedConfirmationDialog.confirmButtonAction);
                this.confirmActionPending = false;
              }

              this.confirmationDialogConfig = null;

            } else {
              this.confirmActionPending = false;
            }
          }
        }
      });
    }
    if (castedConfirmationDialog.abortButtonText) {
      confirmationDialogConfig.buttons.push({
        text: castedConfirmationDialog.abortButtonText || '',
        title: castedConfirmationDialog.abortButtonTitle || '',
        disabled: false,
        loading: false,
        onClick: () => {
          if (castedConfirmationDialog.abortButtonAction) {
            this.handleConfirmationDialogEvents(castedConfirmationDialog.abortButtonAction);
          }
          this.confirmationDialogConfig = null;
        }
      });
    }

    this.confirmationDialogConfig = confirmationDialogConfig;
    this.confirmationDialogConfigRerenderCounter ++;
  }

  private createAndDisplayDynamicDialog(castedConfirmationDialog: DisguiseDto.DisguiseBusinessExceptionDialogDto) {
    const confirmationDialogConfig: ConfirmationDialogConfig = {
      title: castedConfirmationDialog.title || '',
      headerColor: 'primary',
      message: castedConfirmationDialog.message || '',
      onEsc: () => {
        if (castedConfirmationDialog.escapeAction) {
          this.handleDynamicDialogButtonEvents(castedConfirmationDialog.escapeAction);
        }
        this.confirmationDialogConfig = null;
      },
      buttons: [],
      formular: castedConfirmationDialog.formular
    };

    for (const responseButton of (castedConfirmationDialog.buttons || [])) {
      confirmationDialogConfig.buttons.push({
        text: responseButton.text || '',
        title: responseButton.title || '',
        disabled: false,
        loading: false,
        autoFocus: responseButton.autoFocus || false,
        onClick: (button: ConfirmationDialogButton, event, formularInstance) => {
          // synchroner Doppelklick-Schutz (analog case 'DELETE').
          if (this.confirmActionPending) {
            return;
          }
          this.confirmActionPending = true;
          button.loading = true;
          this.confirmationDialogConfigRerenderCounter++;

          if (formularInstance) {
            formularInstance.serializeFormularElementValues().then((formularParameters) => {

              const confirmUrl = responseButton.action ?
                  (responseButton.action as DisguiseDto.DisguiseDialogUrlActionDto).url
                  : '';
              HTTP_SERVICE_INSTANCE.getAxios().post(
                  this.buildRestURL((confirmUrl || ''))).then(() => {
                this.confirmationDialogConfig = null;
              }, () => {
                button.loading = false;
              }).finally(() => {
                this.confirmActionPending = false;
              });
            }, () => {
              button.loading = false;
              this.confirmActionPending = false;
            });
          } else {
            if (responseButton.action) {
              if (responseButton.action['@type'] === 'DisguiseDialogUrlAction') {
                const castedConfirmButtonUrlAction = responseButton.action as DisguiseDto.DisguiseDialogUrlActionDto;
                HTTP_SERVICE_INSTANCE.getAxios().post(
                    this.buildRestURL(castedConfirmButtonUrlAction.url || '')).then(() => {
                  this.confirmationDialogConfig = null;
                }, () => {
                  button.loading = false;
                }).finally(() => {
                  this.confirmActionPending = false;
                });
              } else {
                this.handleDynamicDialogButtonEvents(responseButton.action);
                this.confirmActionPending = false;
              }

              this.confirmationDialogConfig = null;

            } else {
              this.confirmActionPending = false;
            }
          }
        }
      });
    }
    this.confirmationDialogConfig = confirmationDialogConfig;
    this.confirmationDialogConfigRerenderCounter ++;
  }

  private handleConfirmationDialogEvents(confirmationDialogAction: DisguiseDto.ConfirmationDialogActionDto) {
    for (const dialogAction of (confirmationDialogAction.events || [])) {
      if (dialogAction['@type'] === 'FTPropagateGlobalEventDto') {
          const propagateGlobalEventAction = dialogAction as DisguiseDto.FTPropagateGlobalEventDto;
          GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.notifyListener(propagateGlobalEventAction.event || '', propagateGlobalEventAction.globalEventAction);
      }

      if (dialogAction['@type'] === 'SetFieldValueFTEvent') {
        const setFieldValueEvent = dialogAction as DisguiseDto.SetFieldValueFTEventDto;
        const targetFieldState = this.fieldStates[(setFieldValueEvent.fieldName || setFieldValueEvent.customReferenceName || '')];
        const targetVueField = this.lookupFieldReference((setFieldValueEvent.fieldName || setFieldValueEvent.customReferenceName || ''));
        if (targetFieldState && targetVueField) {
          targetFieldState.value = setFieldValueEvent.fieldValue;
          targetVueField.$emit('internalUpdate');
        }
      }
    }
  }

  private handleDynamicDialogButtonEvents(action: DisguiseDto.DisguiseDialogActionDto) {
    for (const dialogAction of (action.events || [])) {
      if (dialogAction['@type'] === 'FTPropagateGlobalEventDto') {
        const propagateGlobalEventAction = dialogAction as DisguiseDto.FTPropagateGlobalEventDto;
        GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.notifyListener(propagateGlobalEventAction.event || '', propagateGlobalEventAction.globalEventAction);
      }

      if (dialogAction['@type'] === 'SetFieldValueFTEvent') {
        const setFieldValueEvent = dialogAction as DisguiseDto.SetFieldValueFTEventDto;
        const targetFieldState = this.fieldStates[(setFieldValueEvent.fieldName || setFieldValueEvent.customReferenceName || '')];
        const targetVueField = this.lookupFieldReference((setFieldValueEvent.fieldName || setFieldValueEvent.customReferenceName || ''));
        if (targetFieldState && targetVueField) {
          targetFieldState.value = setFieldValueEvent.fieldValue;
          targetVueField.$emit('internalUpdate');
        }
      }
    }
  }

  private lookupFieldReference(
      referenceName: string
  ): Vue {
    const fieldRefRaw = (this.$refs as any)[referenceName];
    let fieldRef = fieldRefRaw;
    if (Array.isArray(fieldRefRaw)) {
      // if the reference points to multiple els, take the first
      fieldRef = fieldRefRaw[0];
    }
    return fieldRef as Vue;
  }

  private afterFormularLoaded() {
    if (this.instance && this.instance.input && this.instance.input.onLoadActions) {
      for (const currentAction of this.instance.input.onLoadActions) {
        if (currentAction['@type'] === 'FTFormularLinkDto') {
          let name;
          switch (currentAction.target) {
            case 'BLANK':
              name = '_blank';
              break;
          }
          window.open(currentAction.href, name);
        } else {
          throw new Error('unsupported onload action');
        }
      }
    }
  }

  private executeOptionalUserConfirmationAndThenCb(
      event: DisguiseDto.FTEventV2Dto | DisguiseDto.FTAdvancedButtonEventDto,
      cb: (
          event: DisguiseDto.FTEventV2Dto | DisguiseDto.FTAdvancedButtonEventDto,
          resetDialogButtons: () => void
      ) => void) {
    if (event.optionalUserConfirmation) {
      const cancelButton: ConfirmationDialogButton = {
        title: event.optionalUserConfirmation.abortButtonTitle || '',
        text: event.optionalUserConfirmation.abortButtonText || '',
        loading: false,
        disabled: false,
        onClick: () => {
          this.confirmationDialogConfig = null;
        }
      };
      const confirmButton: ConfirmationDialogButton = {
        title: event.optionalUserConfirmation.confirmButtonTitle || '',
        text: event.optionalUserConfirmation.confirmButtonText || '',
        loading: false,
        disabled: false,
        autoFocus: true,
        onClick: () => {
          confirmButton.loading = true;
          cancelButton.disabled = true;
          cb(event, () => {
            confirmButton.loading = false;
            cancelButton.disabled = false;
          });
        }
      };
      this.confirmationDialogConfig = {
        title: event.optionalUserConfirmation.headerText || 'Bestätigen',
        message: event.optionalUserConfirmation.confirmationText || '',
        onEsc: () => {
          if (!confirmButton.loading) {
            this.confirmationDialogConfig = null;
          }
        },
        headerColor: 'primary',
        buttons: [confirmButton, cancelButton]
      };
      this.confirmationDialogConfigRerenderCounter ++;
    } else {
      cb(event, () => undefined);
    }
  }

  private triggerSaveCloseAndRefreshEventIfConfigured(fieldDefinition: DisguiseDto.IFTRowElementUnion) {
    if (fieldDefinition && fieldDefinition.type === 'FTFieldDto') {
      const castedFieldDefinition = fieldDefinition as DisguiseDto.FTFieldDto;
      for (const currentEvent of castedFieldDefinition.eventsV2 || []) {
        if (currentEvent.type === 'SaveCloseAndRefreshFTEventDto') {
          this.triggerSaveCloseAndRefreshEvent(currentEvent);
        }
      }
    }
  }

  private handleSaveError(error: any, customEndpointUrl?: string, additionalParams?: CompositeKeyType) {
    if (error.response && error.response.data && error.response.data['@type'] === 'FTValidationResultDto') {
      const castedResponse = error.response.data as DisguiseDto.FTValidationResultDto;
      this.$refs.alert.open('Achtung', [castedResponse.validationEntry?.validationMessage || '']);
    } else if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
      if (error.response.data['@type'] === 'DisguiseBusinessExceptionConfirmationDialogDto') {
        const castedResponse = error.response.data as DisguiseDto.DisguiseBusinessExceptionConfirmationDialogDto;
        const confirmationDialogConfig: ConfirmationDialogConfig = {
          title: castedResponse.title || '',
          headerColor: 'primary',
          message: castedResponse.message || '',
          onEsc: () => {
            this.confirmationDialogConfig = null;
          },
          buttons: [],
          formular: castedResponse.formular
        };

        if (castedResponse.confirmButtonText) {
          confirmationDialogConfig.buttons.push({
            text: castedResponse.confirmButtonText || '',
            title: castedResponse.confirmButtonTitle || '',
            disabled: false,
            loading: false,
            autoFocus: true,
            onClick: (button: ConfirmationDialogButton, event, formularInstance) => {
              if (castedResponse.confirmButtonAction) {
                button.loading = true;

                const confirmUrl = castedResponse.confirmButtonAction['@type'] === 'ConfirmationDialogUrlAction' ?
                    (castedResponse.confirmButtonAction as DisguiseDto.ConfirmationDialogUrlActionDto).url : '';

                if (formularInstance) {
                  formularInstance.serializeFormularElementValues().then((formularParameters) => {
                    this.save((confirmUrl || ''),
                        {
                          ...(additionalParams || {}),
                          ...formularParameters
                        }).then(() => {
                      this.confirmationDialogConfig = null;
                    }, () => {
                      button.loading = false;
                    });
                  }, () => {
                    button.loading = false;
                  });
                } else {
                  this.save((confirmUrl || ''), additionalParams).then(() => {
                    this.confirmationDialogConfig = null;
                  }, () => {
                    button.loading = false;
                  });
                }
              } else {
                this.confirmationDialogConfig = null;
              }
            }
          });
        }
        if (castedResponse.abortButtonText) {
          confirmationDialogConfig.buttons.push({
            text: castedResponse.abortButtonText || '',
            title: castedResponse.abortButtonTitle || '',
            disabled: false,
            loading: false,
            onClick: () => {
              this.confirmationDialogConfig = null;
            }
          });
        }

        this.confirmationDialogConfig = confirmationDialogConfig;
        this.confirmationDialogConfigRerenderCounter ++;
      } else if (error.response.data['@type'] === 'DisguiseBusinessExceptionDialogDto') {
        const castedResponse = error.response.data as DisguiseDto.DisguiseBusinessExceptionDialogDto;
        const confirmationDialogConfig: ConfirmationDialogConfig = {
          title: castedResponse.title || '',
          headerColor: 'primary',
          message: castedResponse.message || '',
          onEsc: () => {
            this.confirmationDialogConfig = null;
          },
          buttons: [],
          formular: castedResponse.formular
        };

        for (const responseButton of (castedResponse.buttons || [])) {
          confirmationDialogConfig.buttons.push({
            text: responseButton.text || '',
            title: responseButton.title || '',
            disabled: false,
            loading: false,
            autoFocus: responseButton.autoFocus,
            onClick: (button: ConfirmationDialogButton, event, formularInstance) => {
              if (responseButton && responseButton.action) {
                button.loading = true;

                const confirmUrl = responseButton.action['@type'] === 'DisguiseDialogUrlAction' ?
                    (responseButton.action as DisguiseDto.DisguiseDialogUrlActionDto).url : '';

                if (formularInstance) {
                  formularInstance.serializeFormularElementValues().then((formularParameters) => {
                    this.save((confirmUrl || ''),
                        {
                          ...(additionalParams || {}),
                          ...formularParameters
                        }).then(() => {
                      this.confirmationDialogConfig = null;
                    }, () => {
                      button.loading = false;
                    });
                  }, () => {
                    button.loading = false;
                  });
                } else {
                  this.save((confirmUrl || ''), additionalParams).then(() => {
                    this.confirmationDialogConfig = null;
                  }, () => {
                    button.loading = false;
                  });
                }
              } else {
                this.confirmationDialogConfig = null;
              }
            }
          });
        }

        this.confirmationDialogConfig = confirmationDialogConfig;
        this.confirmationDialogConfigRerenderCounter ++;
      } else {
        this.$store.commit('showSnack', {
          message: 'Speichern fehlgeschlagen',
          color: 'error'
        });
      }
    } else if (!(error)) {
      this.$store.commit('showSnack', {
        message: 'Speichern fehlgeschlagen',
        color: 'error'
      });
    }
    this.instance.loading = false;
  }

  /**
   * Change propagation of context params
   */
  private changeContextParam(patchableContextParams: CompositeKeyType) {
    this.$emit('update-context-parameter', patchableContextParams);
  }

  private unregisterAllGlobalEventListeners() {
    if (this.registeredGlobalEventListenerNames) {
      for (const currentGlobalEventListenerName of this.registeredGlobalEventListenerNames) {
        GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.detachListener(currentGlobalEventListenerName, this.globalEventListenerTriggeredCb);
      }
    }
  }

  private globalEventListenerTriggeredCb(eventData: any) {
    if (eventData) {
      const eventType = eventData['@type'];
      if (eventType) {
        switch (eventType) {
          case 'FTReloadEventActionDto': {
            const castedEventData = eventData as DisguiseDto.FTReloadEventActionDto;
            if (castedEventData.optionalOverridingTemplateUrl !== undefined) {
              this.formularConfig.templateUrl = castedEventData.optionalOverridingTemplateUrl;
            }
            if (castedEventData.optionalOverridingEntityUrl !== undefined) {
              this.formularConfig.entityUrl = castedEventData.optionalOverridingEntityUrl;
            }
            if (castedEventData.optionalOverridingCreate !== undefined) {
              this.formularConfig.create = castedEventData.optionalOverridingCreate;
            }
            this.loadData();
            break;
          }
          case 'FTEmitEventAction': {
            const castedEmitEventAction = eventData as DisguiseDto.FTEmitEventActionDto;
            this.$emit((castedEmitEventAction.eventName || ''));
            break;
          }
          default: {
            break;
          }
        }
      }
    }
  }

  private registerGlobalEventListener(currentGlobalEventListenerName: string) {
    GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.registerListener(currentGlobalEventListenerName, this.globalEventListenerTriggeredCb);
    this.registeredGlobalEventListenerNames.push(currentGlobalEventListenerName);
  }

  private triggerOnSaveActions() {
    if (this.instance && this.instance.input && this.instance.input.onSaveActions) {
      for (const currentAction of this.instance.input.onSaveActions) {
        if (currentAction['@type'] === 'FTPropagateGlobalEventDto') {
          const castedPropagateGlobalEventCfg = currentAction as DisguiseDto.FTPropagateGlobalEventDto;
          if (castedPropagateGlobalEventCfg.event !== undefined
              && castedPropagateGlobalEventCfg.globalEventAction !== undefined) {
            GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.notifyListener(
                castedPropagateGlobalEventCfg.event,
                castedPropagateGlobalEventCfg.globalEventAction
            );
          } else {
            throw new Error('event or globalEventAction undefined!');
          }
        } else if (currentAction['@type'] === 'FTReloadEventDto') {
          const castedEventData = currentAction as DisguiseDto.FTReloadEventDto;
          if (castedEventData.optionalOverridingTemplateUrl !== undefined) {
            this.formularConfig.templateUrl = castedEventData.optionalOverridingTemplateUrl;
          }
          if (castedEventData.optionalOverridingEntityUrl !== undefined) {
            this.formularConfig.entityUrl = castedEventData.optionalOverridingEntityUrl;
          }
          if (castedEventData.optionalOverridingCreate !== undefined) {
            this.formularConfig.create = castedEventData.optionalOverridingCreate;
          }
          this.loadData();
        } else {
          throw new Error('unsupported onsave action');
        }
      }
    }
  }

  private initializeRow(
      row: DisguiseDto.FTRowDto,
      fieldStates: { [uniqueFieldName: string]: AmetrasAdvancedFieldState },
      buttonStates: { [uniqueButtonId: string]: AmetrasAdvancedButtonState }
  ) {
    return {
      ...row,
      fields: ((rowElements: DisguiseDto.IFTRowElementUnion[]) => {
        const fieldResult: DisguiseDto.IFTRowElementUnion[] = [];
        for (const rowElement of rowElements) {
          if (['BasicFTAdvancedButtonDto', 'CallApiFTAdvancedButtonDto', 'ConfirmButtonFTAdvancedButtonDto', 'DialogWithFormularFTAdvancedButtonDto'].indexOf(rowElement.type) >= 0) {
            const castedBtn = rowElement as DisguiseDto.AdvancedButtonDto;

            const hiddenReasons: AmetrasHiddenReasons = {};
            if (castedBtn.hidden === true) {
              hiddenReasons[''] = true; // default hidden condition is applied using blank identifier
            }

            const disabledReasons: AmetrasDisabledReasons = {};
            if (castedBtn.disabled === true) {
              disabledReasons[''] = true; // default disabled condition is applied using blank identifier
            }

            buttonStates[castedBtn.id || ''] = {
              hiddenReasons,
              disabledReasons,
              href: castedBtn.href,
              text: castedBtn.text,
              icon: castedBtn.icon,
            };
            fieldResult.push(rowElement);
          } else if (rowElement.type === 'FTFieldDto') {
            fieldStates[rowElement.customReferenceName || rowElement.fieldName || ''] = {
              value: (rowElement.value !== null ? rowElement.value : ''),
              localErrorReasons: {},
              readonlyReasons: {},
              requiredReasons: {},
              loadingReasons: {},
              affeStyle: {}
            };
            const extendedField: ExtendedFTField = {
              ...rowElement,
              component: DYNAMIC_FIELD_RESOLVER_INSTANCE.resolveComponent(rowElement.uiType, rowElement.dataType),
              fieldEventSubject: new Subject<{ eventName: string; eventArgs: any }>()
            };
            fieldResult.push(extendedField);
          } else {
            fieldResult.push(rowElement);
          }
        }
        return fieldResult;
      })(row.fields || [])
    };
  }

  private afterLoadData(data: DisguiseDto.FTDefinitionDto) {
    this.overwriteFields(data.rows || []);
    new FtReplacementTokenService().replace(data, this.context);
    this.initialDataLoaded = true;
    this.instance.dirty = false;
    this.origInput = JSON.parse(JSON.stringify(data));
    const newFieldStates: {
      [uniqueFieldName: string]: AmetrasAdvancedFieldState
    } = {};
    const newButtonStates: {
      [uniqueButtonId: string]: AmetrasAdvancedButtonState
    } = {};
    this.instance.input = {
      ...data,
      rows: ((originalContents: DisguiseDto.IFormularContent[]) => {
        const extendedContents: ExtendedIFormularContentUnion[] = [];
        for (let contentIdx = 0; contentIdx < (originalContents || []).length; contentIdx++) {
          const currentContent = (originalContents || [])[contentIdx];
          if (currentContent['@type'] === 'FTRowDto') {
            extendedContents.push(
                this.initializeRow(currentContent as DisguiseDto.FTRowDto, newFieldStates, newButtonStates)
            );
          } else if (currentContent['@type'] === 'FTGridDto') {
            const castedContent = currentContent as DisguiseDto.FTGridDto;
            extendedContents.push({
              ...castedContent,
              columns: ((originalGridColumns: DisguiseDto.FTGridColumnDto[]) => {
                const extendedGridColumns: ExtendedFTGridColumnDto[] = [];

                for (const currentGridColumn of originalGridColumns) {
                  extendedGridColumns.push({
                    ...currentGridColumn,
                    content: ((originalGridColumnContents: DisguiseDto.FTRowDto[]) => {
                      const extendedGridColumnContent: ExtendedFTRowDto[] = [];

                      for (const currentGridContent of originalGridColumnContents) {
                        extendedGridColumnContent.push(
                            this.initializeRow(currentGridContent as DisguiseDto.FTRowDto, newFieldStates, newButtonStates)
                        );
                      }

                      return extendedGridColumnContent;
                    })(currentGridColumn.content || [])
                  });
                }

                return extendedGridColumns;
              })(castedContent.columns || [])
            });
          }
        }
        return extendedContents;
      })(data.rows || [])
    };

    this.fieldStates = newFieldStates;
    this.buttonStates = newButtonStates;

    // 1. unregister all existing event listeners
    this.unregisterAllGlobalEventListeners();
    const eventListeners = data.globalEventListeners;
    if (eventListeners) {
      for (const currentGlobalEventListenerName of eventListeners) {
        // 2. register all
        this.registerGlobalEventListener(currentGlobalEventListenerName);
      }
    }

    // field function configuration holds the affe instance. must be reset before each reload
    const initialInit = this.fieldFunctionConfiguration === undefined;
    if (this.fieldFunctionConfiguration) {
      this.fieldFunctionConfiguration.destroy();
      this.fieldFunctionConfiguration = undefined;
    }

    Vue.nextTick().then(() => {
      this.instance.loading = false;
      if (this.$refs.formWrapper) {
        // reset validation after initial load.
        // will be triggered again after form element is touched or form is saved
        this.$refs.formWrapper.resetValidation();
      }
      this.addAdvancedFieldFunctions(initialInit);
      this.afterFormularLoaded();
    });
    this.setFocus();
  }

  private delayUntilPendingAffeRequestCountIsZeroAndFormularIsValid(positiveCB: () => void, negativeCB: () => void) {
    this.$nextTick(() => {
      // wait until AFFE created the necessary requests by waiting for next tick

      SUBJECT_UTILS_INSTANCE.delayUntilSubjectMatchesFilterConditionOnce(
          this.pendingAFFERequestCount,
          (currentCount) => currentCount === 0,
          () => {
            this.$nextTick(() => {
              // wait until AFFE updated the data based on results by waiting for next tick
              const formularIsValid = this.$refs.formWrapper.validate();
              if (formularIsValid) {
                positiveCB();
              } else {
                negativeCB();
              }
            });
          }, () => {
            negativeCB();
          }
      );
    });
  }

}
